import React, { useState, useEffect, useMemo } from 'react';
import Select from 'react-select';
import countryList from 'react-select-country-list';
import { getFunctions, httpsCallable } from "firebase/functions";
import { getApp } from "firebase/app";

// IMPORTACIONES NECESARIAS PARA FIREBASE Y AUTENTICACIÓN
import { initializeApp } from 'firebase/app';
import {
  getAuth,
  onAuthStateChanged,
  signOut,  
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  EmailAuthProvider,
  reauthenticateWithCredential,
  } from 'firebase/auth';

import { getFirestore, collection, addDoc, onSnapshot, serverTimestamp, doc, setDoc, updateDoc, query, where, orderBy, deleteDoc, getDocs, getDoc, collectionGroup, writeBatch, limit, arrayUnion, Timestamp } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
// ===================================================================================
// CONFIGURACIÓN DE FIREBASE
// ===================================================================================
const firebaseConfig = {
  apiKey: "AIzaSyDVf-aAPJ9NYn8b-VxDVkHP6L5TmBo8s18",
  authDomain: "logicstrack-app.firebaseapp.com",
  projectId: "logicstrack-app",
  storageBucket: "logicstrack-app.firebasestorage.app",
  messagingSenderId: "1020249843907",
  appId: "1:1020249843907:web:b10303fc5b1b1f8dcdda76",
  measurementId: "G-0XWXPH7LMG"
};

// --- Zonas Geográficas ---
const zones = {
    maritimo: { origin: ['Asia', 'Europe', 'NorthAmerica', 'SouthAmerica'], destination: ['ElSalvador'] },
    aereo: { origin: ['Asia', 'Europe', 'NorthAmerica', 'SouthAmerica'], destination: ['ElSalvador'] },
    terrestre: { origin: ['Mexico', 'Guatemala', 'Honduras', 'Nicaragua', 'CostaRica', 'Panama'], destination: ['ElSalvador'] }
};

// ===================================================================================
// COMPONENTE GESTIÓN DE EQUIPO (VERSIÓN 2.0 CON PERMISOS DETALLADOS)
// ===================================================================================
const AdminTeamManagement = ({ db, allUsers, logAction }) => {
    const [isSaving, setIsSaving] = useState(null);

    const handlePermissionChange = async (userId, permissionKey, currentValue) => {
        setIsSaving(userId);
        const userDocRef = doc(db, 'artifacts', 'logicstrack-app', 'users', userId);
        const newPermissionValue = !currentValue;
        try {
            await updateDoc(userDocRef, { [`permissions.${permissionKey}`]: newPermissionValue });
            await logAction('PERMISO_CAMBIADO', { 
                targetUserId: userId, 
                permission: permissionKey, 
                newValue: newPermissionValue 
            });
        } catch (error) {
            console.error("Error al cambiar el permiso:", error);
            alert("Hubo un error al actualizar el permiso.");
        } finally {
            setIsSaving(null);
        }
    };

    return (
        <div className="space-y-6">
            <div>
                <h2 className="text-3xl font-bold text-gray-800">Gestión de Equipo y Permisos</h2>
                <p className="text-gray-500 mt-1">
                    Aquí puedes ver a **todos los usuarios registrados**. Usa los interruptores para promover a un usuario a "Admin" o gestionar sus permisos.
                </p>
            </div>
            
            <div className="bg-white border border-gray-200 p-5 rounded-2xl shadow-sm">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                    {/* AHORA MOSTRAMOS TODOS LOS USUARIOS SIN FILTRAR */}
                    {allUsers.map(user => {
                        const permissions = user.permissions || { isAdmin: false, canEditClients: false };
                        return (
                            <div key={user.id} className="border border-gray-200 bg-gray-50/50 p-4 rounded-xl">
                                <h3 className="font-bold text-lg text-gray-800 truncate" title={user.email}>{user.email}</h3>
                                <p className="text-sm text-gray-500 mb-4">ID: {user.uid}</p>
                                
                                <div className="space-y-3 pt-4 border-t">
                                    <label className="flex justify-between items-center cursor-pointer">
                                        <span className="text-sm font-medium text-gray-700">Admin General</span>
                                        <div className="relative inline-flex items-center">
                                            <input type="checkbox" checked={permissions.isAdmin} onChange={() => handlePermissionChange(user.id, 'isAdmin', permissions.isAdmin)} disabled={isSaving === user.id} className="sr-only peer" />
                                            <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-teal-600"></div>
                                        </div>
                                    </label>
                                    
                                    <label className="flex justify-between items-center cursor-pointer">
                                        <span className="text-sm font-medium text-gray-700">Puede Editar Clientes</span>
                                        <div className="relative inline-flex items-center">
                                            <input type="checkbox" checked={permissions.canEditClients} onChange={() => handlePermissionChange(user.id, 'canEditClients', permissions.canEditClients)} disabled={isSaving === user.id} className="sr-only peer" />
                                            <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        );
                    })}
                </div>
                {allUsers.length === 0 && (
                     <div className="text-center py-10"><p className="text-gray-500">No hay usuarios registrados en la base de datos.</p></div>
                )}
            </div>
        </div>
    );
};
// PEGA ESTE COMPONENTE NUEVO EN TU ARCHIVO
const AuditLogViewer = ({ db }) => {
    const [logs, setLogs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!db) return;
        const logCollectionRef = collection(db, 'artifacts', 'logicstrack-app', 'public', 'data', 'audit_log');
        const q = query(logCollectionRef, orderBy('timestamp', 'desc'), limit(100));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const logData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setLogs(logData);
            setIsLoading(false);
        }, (error) => {
            console.error("Error al obtener la bitácora:", error);
            setIsLoading(false);
        });
        return () => unsubscribe();
    }, [db]);

    return (
        <div className="space-y-6">
            <div>
                <h2 className="text-3xl font-bold text-gray-800">Historial de Actividad</h2>
                <p className="text-gray-500 mt-1">Registro de las últimas 100 acciones realizadas en el sistema.</p>
            </div>
            
            <div className="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="min-w-full text-sm">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="py-3 px-4 text-left font-semibold text-gray-600">Fecha y Hora</th>
                                <th className="py-3 px-4 text-left font-semibold text-gray-600">Usuario</th>
                                <th className="py-3 px-4 text-left font-semibold text-gray-600">Acción</th>
                                <th className="py-3 px-4 text-left font-semibold text-gray-600">Detalles</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                            {isLoading ? (
                                <tr><td colSpan="4" className="text-center p-6 text-gray-500">Cargando historial...</td></tr>
                            ) : (
                                logs.map(log => (
                                    <tr key={log.id} className="hover:bg-gray-50">
                                        <td className="py-3 px-4 whitespace-nowrap text-gray-500">
                                            {log.timestamp ? new Date(log.timestamp.seconds * 1000).toLocaleString('es-SV') : 'N/A'}
                                        </td>
                                        <td className="py-3 px-4 text-gray-800">{log.performedBy?.email || 'N/A'}</td>
                                        <td className="py-3 px-4 font-semibold text-teal-700">{log.action}</td>
                                        <td className="py-3 px-4 text-gray-500 font-mono text-xs">
                                            {JSON.stringify(log.details)}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};
// --- Componente Precotizador (Reutilizable) ---
const QuoterComponent = ({ db, ratesConfig, arancelesConfig, classifiedDB, userId, isPublic = false }) => {
    const [step, setStep] = useState(isPublic ? 1 : 2);
    const [clientData, setClientData] = useState({ name: '', email: '', phone: '' });
    const [quoteData, setQuoteData] = useState({
        origin: 'Asia',
        destination: 'ElSalvador',
        transportType: 'Maritimo',
        modality: 'FCL',
        containerType: '40HC',
        equipmentType: '1.5 TN',
        dimensions: { length: 0, width: 0, height: 0 },
        weight: 0,
        cargoType: 'General'
    });
    const [quoteResult, setQuoteResult] = useState(null);
    const [isQuoting, setIsQuoting] = useState(false);
    
    const handleClientSubmit = (e) => {
        e.preventDefault();
        setStep(2);
    };

    const handleProductSelect = (productId) => {
        if (!productId) return;
        const selectedProduct = classifiedDB.find(p => p.id === productId);
        if (selectedProduct) {
            setQuoteData(prevData => ({
                ...prevData,
                cargoType: selectedProduct.partida.startsWith('64') ? 'General' : prevData.cargoType,
            }));
        }
    };

    const handleQuote = async (e) => {
      e.preventDefault();
      setIsQuoting(true);
      setQuoteResult(null);
      if (!ratesConfig) {
          setQuoteResult("Error: Las tarifas no están cargadas. Por favor, configurelas en el panel de Admin.");
          setIsQuoting(false);
          return;
      }

      let finalCost = 0;
      const { origin, destination, transportType, modality, containerType, equipmentType, dimensions, weight, cargoType } = quoteData;
      
      try {
        if (transportType === 'Maritimo' || transportType === 'Aereo') {
            const routeKey = `${origin}_to_${destination}`;
            const routeRates = ratesConfig[transportType.toLowerCase()]?.routes?.[routeKey];
            if (!routeRates) throw new Error(`Ruta ${transportType.toLowerCase()} no encontrada`);

            if(transportType === 'Maritimo') {
                if (modality === 'FCL') {
                    finalCost = routeRates.fcl?.[containerType] || 0;
                } else { // LCL
                    const m3 = (dimensions.length / 100) * (dimensions.width / 100) * (dimensions.height / 100);
                    const costByM3 = m3 * (routeRates.lcl?.tarifaPorM3 || 0);
                    finalCost = costByM3;
                }
            } else { // Aereo
                const volumetricWeight = (dimensions.length * dimensions.width * dimensions.height) / 6000;
                const chargeableWeight = Math.max(weight, volumetricWeight);
                finalCost = chargeableWeight * (routeRates.tarifaPorKg || 0);
            }
        } else { // Terrestre
            if (modality === 'FTL') {
                finalCost = ratesConfig.terrestre?.ftl?.[equipmentType] || 0;
            } else { // LTL
                finalCost = weight * (ratesConfig.terrestre?.ltl?.tarifaPorKg || 0);
            }
        }

        if (cargoType === 'Peligrosa') finalCost *= 1.25;
        
        const resultText = `Costo Logístico Estimado: $${finalCost.toFixed(2)} USD.`;
        setQuoteResult(resultText);

        const appId = 'logicstrack-app';
        const quoteRequestsCollectionRef = collection(db, 'artifacts', appId, 'public', 'data', 'quote_requests');
        await addDoc(quoteRequestsCollectionRef, {
            ...quoteData,
            clientData: isPublic ? clientData : null,
            estimatedCost: finalCost,
            status: 'pending',
            requestDate: serverTimestamp(),
            userId: userId || 'public_user',
        });

      } catch (calcError) {
          console.error("Quoting calculation error:", calcError);
          setQuoteResult(`Error al calcular: ${calcError.message}. Verifique las tarifas en Admin.`);
      }

      setIsQuoting(false);
    };

    // --- ESTILOS CONDICIONALES ---
    const labelStyle = isPublic ? "block text-sm font-medium text-gray-300" : "block text-sm font-medium text-gray-700";
    const inputStyle = isPublic ? "w-full p-2 border rounded-lg mt-1 bg-white text-gray-900" : "w-full p-2 border rounded-lg mt-1";
    const resultBoxStyle = isPublic ? "mt-4 p-4 bg-gray-700 border border-gray-600 rounded-lg text-center" : "mt-4 p-4 bg-teal-50 border border-teal-200 rounded-lg text-center";


    if (step === 1 && isPublic) {
        return (
            <form onSubmit={handleClientSubmit} className="space-y-4">
                <input type="text" placeholder="Nombre Completo" className="w-full p-3 border rounded-lg text-gray-900" value={clientData.name} onChange={e => setClientData({...clientData, name: e.target.value})} required />
                <input type="email" placeholder="Correo Electrónico" className="w-full p-3 border rounded-lg text-gray-900" value={clientData.email} onChange={e => setClientData({...clientData, email: e.target.value})} required />
                <input type="tel" placeholder="Teléfono" className="w-full p-3 border rounded-lg text-gray-900" value={clientData.phone} onChange={e => setClientData({...clientData, phone: e.target.value})} required />
                <button type="submit" className="w-full bg-teal-600 text-white font-bold py-3 px-4 rounded-lg shadow-md hover:bg-teal-700">Cotiza Ahora</button>
            </form>
        );
    }

    return (
        <form onSubmit={handleQuote} className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className={labelStyle}>Origen</label>
                        <select value={quoteData.origin} onChange={e => setQuoteData({...quoteData, origin: e.target.value})} className={inputStyle}>
                            {zones[quoteData.transportType.toLowerCase()].origin.map(z => <option key={z} value={z}>{z}</option>)}
                        </select>
                    </div>
                    <div>
                        <label className={labelStyle}>Destino</label>
                        <p className={`w-full p-2 mt-1 font-semibold ${isPublic ? 'text-white' : 'text-gray-800'}`}>{zones[quoteData.transportType.toLowerCase()].destination[0]}</p>
                    </div>
                </div>
                <div>
                    <label className={labelStyle}>Tipo de Transporte</label>
                    <select value={quoteData.transportType} onChange={e => setQuoteData({...quoteData, transportType: e.target.value, modality: e.target.value === 'Terrestre' ? 'FTL' : 'FCL'})} className={inputStyle}>
                        <option value="Maritimo">Marítimo</option><option value="Terrestre">Terrestre</option><option value="Aereo">Aéreo</option>
                    </select>
                </div>

                {quoteData.transportType === 'Maritimo' && (
                     <div>
                        <label className={labelStyle}>Modalidad Marítima</label>
                        <select value={quoteData.modality} onChange={e => setQuoteData({...quoteData, modality: e.target.value})} className={inputStyle}>
                            <option value="FCL">FCL (Contenedor Completo)</option><option value="LCL">LCL (Carga Suelta)</option>
                        </select>
                    </div>
                )}
                
                {quoteData.transportType === 'Terrestre' && (
                    <div>
                        <label className={labelStyle}>Modalidad Terrestre</label>
                        <select value={quoteData.modality} onChange={e => setQuoteData({...quoteData, modality: e.target.value})} className={inputStyle}>
                            <option value="FTL">FTL (Camión Completo)</option><option value="LTL">LTL (Carga Suelta)</option>
                        </select>
                    </div>
                )}
                 {quoteData.transportType === 'Maritimo' && quoteData.modality === 'FCL' && (
                     <div>
                        <label className={labelStyle}>Tipo de Contenedor</label>
                        <select className={inputStyle} value={quoteData.containerType} onChange={e => setQuoteData({...quoteData, containerType: e.target.value})}>
                            <option value="20GP">20' Estándar</option><option value="40GP">40' Estándar</option><option value="40HC">40' High Cube</option>
                        </select>
                    </div>
                )}
                
                {quoteData.transportType === 'Terrestre' && quoteData.modality === 'FTL' && (
                    <div>
                        <label className={labelStyle}>Tipo de Equipo</label>
                        <select className={inputStyle} value={quoteData.equipmentType} onChange={e => setQuoteData({...quoteData, equipmentType: e.target.value})}>
                            <option>1.5 TN</option><option>5 TN</option><option>8 TN</option><option>43 pies</option>
                        </select>
                    </div>
                )}
            </div>
            <div className="space-y-4">
                 <div>
                    <label className={labelStyle}>Tipo de Carga</label>
                    <select className={inputStyle} value={quoteData.cargoType} onChange={e => setQuoteData({...quoteData, cargoType: e.target.value})}>
                        <option>General</option><option>Peligrosa</option><option>Refrigerada</option>
                    </select>
                </div>
                {((quoteData.transportType === 'Maritimo' && quoteData.modality === 'LCL') || (quoteData.transportType === 'Terrestre' && quoteData.modality === 'LTL') || quoteData.transportType === 'Aereo') && (
                    <div className={`p-4 rounded-lg border space-y-3 ${isPublic ? 'bg-gray-800/50 border-gray-600' : 'bg-gray-50 border-gray-200'}`}>
                        <h3 className={`font-semibold ${isPublic ? 'text-white' : 'text-gray-800'}`}>Detalles de Carga</h3>
                        <input type="number" placeholder="Peso (kg)" className={inputStyle} onChange={e => setQuoteData({...quoteData, weight: parseFloat(e.target.value)})} />
                        <div className="grid grid-cols-3 gap-2">
                            <input type="number" placeholder="Largo (cm)" className={inputStyle} onChange={e => setQuoteData({...quoteData, dimensions: {...quoteData.dimensions, length: parseFloat(e.target.value)}})} />
                            <input type="number" placeholder="Ancho (cm)" className={inputStyle} onChange={e => setQuoteData({...quoteData, dimensions: {...quoteData.dimensions, width: parseFloat(e.target.value)}})} />
                            <input type="number" placeholder="Alto (cm)" className={inputStyle} onChange={e => setQuoteData({...quoteData, dimensions: {...quoteData.dimensions, height: parseFloat(e.target.value)}})} />
                        </div>
                    </div>
                )}
                {!isPublic && classifiedDB && classifiedDB.length > 0 && (
                    <div className="mt-4 pt-4 border-t border-gray-200">
                        <label className={labelStyle}>O selecciona un producto guardado:</label>
                        <select onChange={e => handleProductSelect(e.target.value)} className={inputStyle}>
                            <option value="">-- Elige un producto --</option>
                            {classifiedDB.map(prod => (
                                <option key={prod.id} value={prod.id}>{prod.descripcion_comercial}</option>
                            ))}
                        </select>
                    </div>
                )}
                <button type="submit" className="w-full bg-teal-600 text-white font-bold py-3 px-4 rounded-lg shadow-md" disabled={isQuoting}>
                    {isQuoting ? 'Calculando...' : 'Cotizar Envío'}
                </button>
                {quoteResult && (
                    <div className={resultBoxStyle}>
                        <p className="font-semibold">{quoteResult}</p>
                    </div>
                )}
            </div>
        </form>
    );
};

// --- Componente de Página Pública (Login y Precotizador) ---
const PublicPage = ({ onLogin, onRegister, db, ratesConfig, arancelesConfig, classifiedDB, userId }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [mode, setMode] = useState('login');
    const handleAuthSubmit = (e) => {
        e.preventDefault();
        setError('');
        if (mode === 'login') {
            onLogin(email, password).catch(err => setError("Correo o contraseña incorrectos."));
        } else {
            onRegister(email, password).catch(err => setError("No se pudo crear la cuenta. Inténtalo de nuevo."));
        }
    };

  return (
    <div className="min-h-screen bg-gray-900 text-white font-['Inter'] flex flex-col">
        {/* === BARRA DE NAVEGACIÓN SUPERIOR CON TAMAÑO AUMENTADO === */}
        <nav className="w-full p-4 flex justify-between items-center">
            <div className="flex items-center space-x-3">
                <img 
                    src="https://firebasestorage.googleapis.com/v0/b/logicstrack-app.firebasestorage.app/o/logotipo1.png?alt=media&token=245b5ced-2e7e-46fd-94bd-b3b693ceb286" 
                    alt="Logotipo de LogicsTrack" 
                    className="h-12 md:h-14 lg:h-16 w-auto" // Aumento de tamaño en PC (lg)
                />
                <span className="text-2xl md:text-3xl lg:text-4xl font-bold bg-gradient-to-r from-cyan-400 to-teal-500 bg-clip-text text-transparent">
                    LogicsTrack
                </span>
            </div>
        </nav>
        
        <div className="flex-grow flex items-center justify-center p-4">
            <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                <div className="text-center lg:text-left">
                    <h1 className="text-5xl lg:text-6xl font-extrabold leading-tight mb-4">
                     Tu Mundo, <span className="text-teal-500">Conectado.</span><br/>Logística sin Fronteras.
                     </h1>
                    <p className="text-lg text-gray-300 mb-8">
                        Optimiza tus envíos, cotiza al instante y gestiona tu carga con inteligencia artificial.
                 </p>
                </div>
                <div className="bg-gray-800/60 backdrop-blur-lg p-8 md:p-12 rounded-2xl shadow-2xl shadow-teal-500/10 border border-gray-700">
                    {mode === 'quote' ?
 (
                        <>
                            <h2 className="text-3xl font-bold text-center mb-6">Cotiza tu Envío Gratis</h2>
                            <QuoterComponent db={db} ratesConfig={ratesConfig} arancelesConfig={arancelesConfig} classifiedDB={classifiedDB} userId={userId} isPublic={true} />
                            <button onClick={() => setMode('login')} className="w-full mt-4 text-teal-400 hover:text-teal-300">Volver a Iniciar Sesión</button>
                        </>
                    ) : (
                        <div className="flex flex-col items-center">
                            
                            {/* === LOGO DENTRO DEL FORMULARIO CON TAMAÑO AUMENTADO === */}
                            <div className="relative mb-8">
                                <div className="absolute -inset-2 bg-teal-500/20 rounded-full blur-xl"></div>
                                <img 
                                    src="https://firebasestorage.googleapis.com/v0/b/logicstrack-app.firebasestorage.app/o/logotipo1.png?alt=media&token=245b5ced-2e7e-46fd-94bd-b3b693ceb286" 
                                    alt="Logotipo" 
                                    className="h-16 md:h-20 lg:h-24 w-auto relative" // Aumento de tamaño en PC (lg)
                                />
                            </div>

                            <h2 className="text-3xl font-bold text-center mb-6">{mode === 'login' ? 'Bienvenido de Nuevo' : 'Crea tu Cuenta'}</h2>
                            <form onSubmit={handleAuthSubmit} className="w-full space-y-6">
                                {/* CAMPO DE CORREO CON ICONO */}
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                            <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                            <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                        </svg>
                                    </div>
                                    <input 
                                        type="email" 
                                        placeholder="Correo Electrónico" 
                                        className="w-full p-3 pl-10 border border-gray-600 bg-gray-700 text-white rounded-lg focus:ring-2 focus:ring-teal-500 transition-all" 
                                        value={email} 
                                        onChange={e => setEmail(e.target.value)} 
                                    />
                                </div>
                                
                                {/* CAMPO DE CONTRASEÑA CON ICONO */}
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M10 1a4.5 4.5 0 00-4.5 4.5V9H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-.5V5.5A4.5 4.5 0 0010 1zm3 8V5.5a3 3 0 10-6 0V9h6z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <input 
                                        type="password" 
                                        placeholder="Contraseña" 
                                        className="w-full p-3 pl-10 border border-gray-600 bg-gray-700 text-white rounded-lg focus:ring-2 focus:ring-teal-500 transition-all" 
                                        value={password} 
                                        onChange={e => setPassword(e.target.value)} 
                                    />
                                </div>

                                {error && <p className="text-red-400 text-sm text-center">{error}</p>}
                                <button type="submit" className="w-full bg-teal-600 text-white font-bold py-3 px-4 rounded-lg shadow-md hover:bg-teal-700 transition-all duration-300 transform hover:scale-105">
                                    {mode === 'login' ? 'Entrar' : 'Registrarse'}
                                </button>
                                <div className="text-center text-sm">
                                    {mode === 'login' ? (
                                        <p>¿No tienes cuenta? <button type="button" onClick={() => { setMode('register'); setError(''); }} className="font-semibold text-teal-400 hover:text-teal-300">Regístrate</button></p>
                                    ) : (
                                        <p>¿Ya tienes cuenta? <button type="button" onClick={() => { setMode('login'); setError(''); }} className="font-semibold text-teal-400 hover:text-teal-300">Inicia Sesión</button></p>
                                    )}
                                    <p className="mt-2">O <button type="button" onClick={() => setMode('quote')} className="font-semibold text-teal-400 hover:text-teal-300">Continúa para cotizar</button></p>
                                </div>
                            </form>
                        </div>
                    )}
                </div>
            </div>
        </div>
    </div>
  );
};
// PEGA ESTE NUEVO COMPONENTE DEBAJO DE 'PublicPage'
const PrivacyPolicyPage = () => {
  return (
    <div className="space-y-6">
        <div>
            <h2 className="text-3xl font-bold text-gray-800">Política de Privacidad</h2>
            <p className="text-gray-500 mt-1">Última actualización: 23 de septiembre de 2025</p>
        </div>
        <div className="bg-white border border-gray-200 p-6 sm:p-8 rounded-2xl shadow-sm">
            <div className="prose max-w-none">
                <p>En LogicsTrack, valoramos tu privacidad y nos comprometemos a proteger la información personal que compartes con nosotros. Esta política describe cómo recopilamos, usamos, almacenamos y protegemos tus datos cuando utilizas nuestra aplicación.</p>
                
                <h3>Información que Recopilamos</h3>
                <ul>
                    <li><strong>Datos personales:</strong> nombre, correo electrónico, número de teléfono, empresa.</li>
                    <li><strong>Datos operativos:</strong> información sobre envíos, rutas, entregas, tiempos estimados, y otros datos relacionados con la operación logística.</li>
                    <li><strong>Datos técnicos:</strong> tipo de dispositivo, sistema operativo, dirección IP, y datos de uso de la app.</li>
                </ul>

                <h3>Cómo Usamos Tu Información</h3>
                <p>Utilizamos tus datos para:</p>
                <ul>
                    <li>Proporcionar y mejorar nuestros servicios logísticos.</li>
                    <li>Optimizar rutas y tiempos de entrega.</li>
                    <li>Enviar notificaciones relevantes sobre el estado de tus envíos.</li>
                    <li>Garantizar la seguridad y el funcionamiento correcto de la aplicación.</li>
                    <li>Cumplir con obligaciones legales y regulatorias.</li>
                </ul>

                <h3>Seguridad de los Datos</h3>
                <p>Implementamos medidas técnicas y organizativas para proteger tu información contra accesos no autorizados, pérdida o alteración. Esto incluye cifrado de datos, autenticación segura y monitoreo continuo.</p>
                
                <h3>Contacto</h3>
                <p>Si tienes preguntas sobre esta política o sobre cómo manejamos tus datos, contáctanos en:</p>
                <p>
                    Networld Logistics / LogicsTrack <br />
                    📧 Aduana@networldslogistics.com <br />
                    📍 Antiguo Cuscatlán, El Salvador
                </p>
            </div>
        </div>
    </div>
  );
};


// --- COMPONENTES DE PESTAÑAS (DEFINIDOS FUERA DEL COMPONENTE PRINCIPAL) ---
// LISTA DE ACTIVIDADES ECONÓMICAS COMPLETA Y DEFINITIVA (FUSIÓN DE AMBAS LISTAS)
// Esta lista debe ir fuera del componente, en la parte superior del archivo.
const actividadesEconomicas = [
    { code: '01111', description: 'Cultivo de cereales excepto arroz y para forrajes' },
    { code: '01112', description: 'Cultivo de legumbres' },
    { code: '01113', description: 'Cultivo de semillas oleaginosas' },
    { code: '01114', description: 'Cultivo de plantas para la preparación de semillas' },
    { code: '01119', description: 'Cultivo de otros cereales excepto arroz y forrajeros n.c.p.' },
    { code: '01120', description: 'Cultivo de arroz' },
    { code: '01131', description: 'Cultivo de raíces y tubérculos' },
    { code: '01132', description: 'Cultivo de brotes, bulbos, vegetales tubérculos y cultivos similares' },
    { code: '01133', description: 'Cultivo hortícola de fruto' },
    { code: '01134', description: 'Cultivo de hortalizas de hoja y otras hortalizas ncp' },
    { code: '01140', description: 'Cultivo de caña de azúcar' },
    { code: '01150', description: 'Cultivo de tabaco' },
    { code: '01161', description: 'Cultivo de algodón' },
    { code: '01162', description: 'Cultivo de fibras vegetales excepto algodón' },
    { code: '01191', description: 'Cultivo de plantas no perennes para la producción de semillas yflores' },
    { code: '01192', description: 'Cultivo de cereales y pastos para la alimentación animal' },
    { code: '01199', description: 'Producción de cultivos no estacionales ncp' },
    { code: '01220', description: 'Cultivo de frutas tropicales' },
    { code: '01230', description: 'Cultivo de cítricos' },
    { code: '01240', description: 'Cultivo de frutas de pepita y hueso' },
    { code: '01251', description: 'Cultivo de frutas ncp' },
    { code: '01252', description: 'Cultivo de otros frutos y nueces de árboles y arbustos' },
    { code: '01260', description: 'Cultivo de frutos oleaginosos' },
    { code: '01271', description: 'Cultivo de café' },
    { code: '01272', description: 'Cultivo de plantas para la elaboración de bebidas excepto café' },
    { code: '01281', description: 'Cultivo de especias y aromáticas' },
    { code: '01282', description: 'Cultivo de plantas para la obtención de productos medicinales yfarmacéuticos' },
    { code: '01291', description: 'Cultivo de árboles de hule (caucho) para la obtención de látex' },
    { code: '01292', description: 'Cultivo de plantas para la obtención de productos químicos ycolorantes' },
    { code: '01299', description: 'Producción de cultivos perennes ncp' },
    { code: '01300', description: 'Propagación de plantas' },
    { code: '01301', description: 'Cultivo de plantas y flores ornamentales' },
    { code: '01410', description: 'Cría y engorde de ganado bovino' },
    { code: '01420', description: 'Cría de caballos y otros equinos' },
    { code: '01440', description: 'Cría de ovejas y cabras' },
    { code: '01450', description: 'Cría de cerdos' },
    { code: '01460', description: 'Cría de aves de corral y producción de huevos' },
    { code: '01491', description: 'Cría de abejas apicultura para la obtención de miel y otros productos apícolas' },
    { code: '01492', description: 'Cría de conejos' },
    { code: '01493', description: 'Cría de iguanas y garrobos' },
    { code: '01494', description: 'Cría de mariposas y otros insectos' },
    { code: '01499', description: 'Cría y obtención de productos animales n.c.p.' },
    { code: '01500', description: 'Cultivo de productos agrícolas en combinación con la cría de animales' },
    { code: '01611', description: 'Servicios de maquinaria agrícola' },
    { code: '01612', description: 'Control de plagas' },
    { code: '01613', description: 'Servicios de riego' },
    { code: '01614', description: 'Servicios de contratación de mano de obra para la agricultura' },
    { code: '01619', description: 'Servicios agrícolas ncp' },
    { code: '01621', description: 'Actividades para mejorar la reproducción, el crecimiento y el rendimiento de los animales y sus productos' },
    { code: '01622', description: 'Servicios de mano de obra pecuaria' },
    { code: '01629', description: 'Servicios pecuarios ncp' },
    { code: '01631', description: 'Labores post cosecha de preparación de los productos agrícolas para su comercialización o para la industria' },
    { code: '01632', description: 'Servicio de beneficio de café' },
    { code: '01633', description: 'Servicio de beneficiado de plantas textiles (incluye el beneficiado cuando este es realizado en la misma explotación agropecuaria)' },
    { code: '01640', description: 'Tratamiento de semillas para la propagación' },
    { code: '01700', description: 'Caza ordinaria y mediante trampas, repoblación de animales de caza y servicios conexos' },
    { code: '02100', description: 'Silvicultura y otras actividades forestales' },
    { code: '02200', description: 'Extracción de madera' },
    { code: '02300', description: 'Recolección de productos diferentes a la madera' },
    { code: '02400', description: 'Servicios de apoyo a la silvicultura' },
    { code: '03110', description: 'Pesca marítima de altura y costera' },
    { code: '03120', description: 'Pesca de agua dulce' },
    { code: '03210', description: 'Acuicultura marítima' },
    { code: '03220', description: 'Acuicultura de agua dulce' },
    { code: '03300', description: 'Servicios de apoyo a la pesca y acuicultura' },
    { code: '05100', description: 'Extracción de hulla' },
    { code: '05200', description: 'Extracción y aglomeración de lignito' },
    { code: '06100', description: 'Extracción de petróleo crudo' },
    { code: '06200', description: 'Extracción de gas natural' },
    { code: '07100', description: 'Extracción de minerales de hierro' },
    { code: '07210', description: 'Extracción de minerales de uranio y torio' },
    { code: '07290', description: 'Extracción de minerales metalíferos no ferrosos' },
    { code: '08100', description: 'Extracción de piedra, arena y arcilla' },
    { code: '08910', description: 'Extracción de minerales para la fabricación de abonos y productosquímicos' },
    { code: '08920', description: 'Extracción y aglomeración de turba' },
    { code: '08930', description: 'Extracción de sal' },
    { code: '08990', description: 'Explotación de otras minas y canteras ncp' },
    { code: '09100', description: 'Actividades de apoyo a la extracción de petróleo y gas natural' },
    { code: '09900', description: 'Actividades de apoyo a la explotación de minas y canteras' },
    { code: '10001', description: 'Empleados' },
    { code: '10002', description: 'Jubilado' },
    { code: '10003', description: 'Estudiante' },
    { code: '10004', description: 'Desempleado' },
    { code: '10005', description: 'Otros' },
    { code: '10101', description: 'Servicio de rastros y mataderos de bovinos y porcinos' },
    { code: '10102', description: 'Matanza y procesamiento de bovinos y porcinos' },
    { code: '10103', description: 'Matanza y procesamientos de aves de corral' },
    { code: '10104', description: 'Elaboración y conservación de embutidos y tripas naturales' },
    { code: '10105', description: 'Servicios de conservación y empaque de carnes' },
    { code: '10106', description: 'Elaboración y conservación de grasas y aceites animales' },
    { code: '10107', description: 'Servicios de molienda de carne' },
    { code: '10108', description: 'Elaboración de productos de carne ncp' },
    { code: '10201', description: 'Procesamiento y conservación de pescado, crustáceos y moluscos' },
    { code: '10209', description: 'Fabricación de productos de pescado ncp' },
    { code: '10301', description: 'Elaboración de jugos de frutas y hortalizasv' },
    { code: '10302', description: 'Elaboración y envase de jaleas, mermeladas y frutas deshidratadas' },
    { code: '10309', description: 'Elaboración de productos de frutas y hortalizas n.c.p.' },
    { code: '10401', description: 'Fabricación de aceites y grasas vegetales y animales comestibles' },
    { code: '10402', description: 'Fabricación de aceites y grasas vegetales y animales no comestibles' },
    { code: '10409', description: 'Servicio de maquilado de aceites' },
    { code: '10501', description: 'Fabricación de productos lácteos excepto sorbetes y quesos sustitutos' },
    { code: '10502', description: 'Fabricación de sorbetes y helados' },
    { code: '10503', description: 'Fabricación de quesos' },
    { code: '10611', description: 'Molienda de cereales' },
    { code: '10612', description: 'Elaboración de cereales para el desayuno y similares' },
    { code: '10613', description: 'Servicios de beneficiado de productos agrícolas ncp (excluye Beneficio de azúcar rama 1072 y beneficio de café rama 0163)' },
    { code: '10621', description: 'Fabricación de almidón' },
    { code: '10628', description: 'Servicio de molienda de maíz húmedo molino para nixtamal' },
    { code: '10711', description: 'Elaboración de tortillas' },
    { code: '10712', description: 'Fabricación de pan, galletas y barquillos' },
    { code: '10713', description: 'Fabricación de repostería' },
    { code: '10721', description: 'Ingenios azucareros' },
    { code: '10722', description: 'Molienda de caña de azúcar para la elaboración de dulces' },
    { code: '10723', description: 'Elaboración de jarabes de azúcar y otros similares' },
    { code: '10724', description: 'Maquilado de azúcar de caña' },
    { code: '10730', description: 'Fabricación de cacao, chocolates y productos de confitería' },
    { code: '10740', description: 'Elaboración de macarrones, fideos, y productos farináceos similares' },
    { code: '10750', description: 'Elaboración de comidas y platos preparados para la reventa enlocales y/o para exportación' },
    { code: '10791', description: 'Elaboración de productos de café' },
    { code: '10792', description: 'Elaboración de especies, sazonadores y condimentos' },
    { code: '10793', description: 'Elaboración de sopas, cremas y consomé' },
    { code: '10794', description: 'Fabricación de bocadillos tostados y/o fritos' },
    { code: '10799', description: 'Elaboración de productos alimenticios ncp' },
    { code: '10800', description: 'Elaboración de alimentos preparados para animales' },
    { code: '11012', description: 'Fabricación de aguardiente y licores' },
    { code: '11020', description: 'Elaboración de vinos' },
    { code: '11030', description: 'Fabricación de cerveza' },
    { code: '11041', description: 'Fabricación de aguas gaseosas' },
    { code: '11042', description: 'Fabricación y envasado de agua' },
    { code: '11043', description: 'Elaboración de refrescos' },
    { code: '11048', description: 'Maquilado de aguas gaseosas' },
    { code: '11049', description: 'Elaboración de bebidas no alcohólicas' },
    { code: '12000', description: 'Elaboración de productos de tabaco' },
    { code: '13111', description: 'Preparación de fibras textiles' },
    { code: '13112', description: 'Fabricación de hilados' },
    { code: '13120', description: 'Fabricación de telas' },
    { code: '13130', description: 'Acabado de productos textiles' },
    { code: '13910', description: 'Fabricación de tejidos de punto y ganchillo' },
    { code: '13921', description: 'Fabricación de productos textiles para el hogar' },
    { code: '13922', description: 'Sacos, bolsas y otros artículos textiles' },
    { code: '13929', description: 'Fabricación de artículos confeccionados con materiales textiles,excepto prendas de vestir ncp' },
    { code: '13930', description: 'Fabricación de tapices y alfombras' },
    { code: '13941', description: 'Fabricación de cuerdas de henequén y otras fibras naturales (lazos,pitas)' },
    { code: '13942', description: 'Fabricación de redes de diversos materiales' },
    { code: '13948', description: 'Maquilado de productos trenzables de cualquier material (petates,sillas, etc.)' },
    { code: '13991', description: 'Fabricación de adornos, etiquetas y otros artículos para prendas devestir' },
    { code: '13992', description: 'Servicio de bordados en artículos y prendas de tela' },
    { code: '13999', description: 'Fabricación de productos textiles ncp' },
    { code: '14101', description: 'Fabricación de ropa interior, para dormir y similares' },
    { code: '14102', description: 'Fabricación de ropa para niños' },
    { code: '14103', description: 'Fabricación de prendas de vestir para ambos sexos' },
    { code: '14104', description: 'Confección de prendas a medida' },
    { code: '14105', description: 'Fabricación de prendas de vestir para deportes' },
    { code: '14106', description: 'Elaboración de artesanías de uso personal confeccionadasespecialmente de materiales textiles' },
    { code: '14108', description: 'Maquilado de prendas de vestir, accesorios y otros' },
    { code: '14109', description: 'Fabricación de prendas y accesorios de vestir n.c.p.' },
    { code: '14200', description: 'Fabricación de artículos de piel' },
    { code: '14301', description: 'Fabricación de calcetines, calcetas, medias (panty house) y otrossimilares' },
    { code: '14302', description: 'Fabricación de ropa interior de tejido de punto' },
    { code: '14309', description: 'Fabricación de prendas de vestir de tejido de punto ncp' },
    { code: '15110', description: 'Curtido y adobo de cueros; adobo y teñido de pieles' },
    { code: '15121', description: 'Fabricación de maletas, bolsos de mano y otros artículos demarroquinería' },
    { code: '15122', description: 'Fabricación de monturas, accesorios y vainas talabartería' },
    { code: '15123', description: 'Fabricación de artesanías principalmente de cuero natural ysintético' },
    { code: '15128', description: 'Maquilado de artículos de cuero natural, sintético y de otrosmateriales' },
    { code: '15201', description: 'Fabricación de calzado' },
    { code: '15202', description: 'Fabricación de partes y accesorios de calzado' },
    { code: '15208', description: 'Maquilado de partes y accesorios de calzado' },
    { code: '16100', description: 'Aserradero y acepilladura de madera' },
    { code: '16210', description: 'Fabricación de madera laminada, terciada, enchapada ycontrachapada, paneles para la construcción' },
    { code: '16220', description: 'Fabricación de partes y piezas de carpintería para edificios yconstrucciones' },
    { code: '16230', description: 'Fabricación de envases y recipientes de madera' },
    { code: '16292', description: 'Fabricación de artesanías de madera, semillas, materiales trenzables' },
    { code: '16299', description: 'Fabricación de productos de madera, corcho, paja y materialestrenzables ncp' },
    { code: '17010', description: 'Fabricación de pasta de madera, papel y cartón' },
    { code: '17020', description: 'Fabricación de papel y cartón ondulado y envases de papel y cartón' },
    { code: '17091', description: 'Fabricación de artículos de papel y cartón de uso personal ydoméstico' },
    { code: '17092', description: 'Fabricación de productos de papel ncp' },
    { code: '18110', description: 'Impresión' },
    { code: '18120', description: 'Servicios relacionados con la impresión' },
    { code: '18200', description: 'Reproducción de grabaciones' },
    { code: '19100', description: 'Fabricación de productos de hornos de coque' },
    { code: '19201', description: 'Fabricación de combustible' },
    { code: '19202', description: 'Fabricación de aceites y lubricantes' },
    { code: '20111', description: 'Fabricación de materias primas para la fabricación de colorantes' },
    { code: '20112', description: 'Fabricación de materiales curtientes' },
    { code: '20113', description: 'Fabricación de gases industriales' },
    { code: '20114', description: 'Fabricación de alcohol etílico' },
    { code: '20119', description: 'Fabricación de sustancias químicas básicas' },
    { code: '20120', description: 'Fabricación de abonos y fertilizantes' },
    { code: '20130', description: 'Fabricación de plástico y caucho en formas primarias' },
    { code: '20210', description: 'Fabricación de plaguicidas y otros productos químicos de usoagropecuario' },
    { code: '20220', description: 'Fabricación de pinturas, barnices y productos de revestimientosimilares; tintas de imprenta y masillas' },
    { code: '20231', description: 'Fabricación de jabones, detergentes y similares para limpieza' },
    { code: '20232', description: 'Fabricación de perfumes, cosméticos y productos de higiene ycuidado personal, incluyendo tintes, champú, etc.' },
    { code: '20291', description: 'Fabricación de tintas y colores para escribir y pintar; fabricación decintas para impresoras' },
    { code: '20292', description: 'Fabricación de productos pirotécnicos, explosivos y municiones' },
    { code: '20299', description: 'Fabricación de productos químicos n.c.p.' },
    { code: '20300', description: 'Fabricación de fibras artificiales' },
    { code: '21001', description: 'Manufactura de productos farmacéuticos, sustancias químicas yproductos botánicos' },
    { code: '21008', description: 'Maquilado de medicamentos' },
    { code: '22110', description: 'Fabricación de cubiertas y cámaras; renovación y recauchutado decubiertas' },
    { code: '22190', description: 'Fabricación de otros productos de caucho' },
    { code: '22201', description: 'Fabricación de envases plásticos' },
    { code: '22202', description: 'Fabricación de productos plásticos para uso personal o doméstico' },
    { code: '22208', description: 'Maquila de plásticos' },
    { code: '22209', description: 'Fabricación de productos plásticos n.c.p.' },
    { code: '23101', description: 'Fabricación de vidrio' },
    { code: '23102', description: 'Fabricación de recipientes y envases de vidrio' },
    { code: '23108', description: 'Servicio de maquilado' },
    { code: '23109', description: 'Fabricación de productos de vidrio ncp' },
    { code: '23910', description: 'Fabricación de productos refractarios' },
    { code: '23920', description: 'Fabricación de productos de arcilla para la construcción' },
    { code: '23931', description: 'Fabricación de productos de cerámica y porcelana no refractaria' },
    { code: '23932', description: 'Fabricación de productos de cerámica y porcelana ncp' },
    { code: '23940', description: 'Fabricación de cemento, cal y yeso' },
    { code: '23950', description: 'Fabricación de artículos de hormigón, cemento y yeso' },
    { code: '23960', description: 'Corte, tallado y acabado de la piedra' },
    { code: '23990', description: 'Fabricación de productos minerales no metálicos ncp' },
    { code: '24100', description: 'Industrias básicas de hierro y acero' },
    { code: '24200', description: 'Fabricación de productos primarios de metales preciosos y metalesno ferrosos' },
    { code: '24310', description: 'Fundición de hierro y acero' },
    { code: '24320', description: 'Fundición de metales no ferrosos' },
    { code: '25111', description: 'Fabricación de productos metálicos para uso estructural' },
    { code: '25118', description: 'Servicio de maquila para la fabricación de estructuras metálicas' },
    { code: '25120', description: 'Fabricación de tanques, depósitos y recipientes de metal' },
    { code: '25130', description: 'Fabricación de generadores de vapor, excepto calderas de aguacaliente para calefacción central' },
    { code: '25200', description: 'Fabricación de armas y municiones' },
    { code: '25910', description: 'Forjado, prensado, estampado y laminado de metales;pulvimetalurgia' },
    { code: '25920', description: 'Tratamiento y revestimiento de metales' },
    { code: '25930', description: 'Fabricación de artículos de cuchillería, herramientas de mano yartículos de ferretería' },
    { code: '25991', description: 'Fabricación de envases y artículos conexos de metal' },
    { code: '25992', description: 'Fabricación de artículos metálicos de uso personal y/o doméstico' },
    { code: '25999', description: 'Fabricación de productos elaborados de metal ncp' },
    { code: '26100', description: 'Fabricación de componentes electrónicos' },
    { code: '26200', description: 'Fabricación de computadoras y equipo conexo' },
    { code: '26300', description: 'Fabricación de equipo de comunicaciones' },
    { code: '26400', description: 'Fabricación de aparatos electrónicos de consumo para audio, videoradio y televisión' },
    { code: '26510', description: 'Fabricación de instrumentos y aparatos para medir, verificar,ensayar, navegar y de control de procesos industriales' },
    { code: '26520', description: 'Fabricación de relojes y piezas de relojes' },
    { code: '26600', description: 'Fabricación de equipo médico de irradiación y equipo electrónicode uso médico y terapéutico' },
    { code: '26700', description: 'Fabricación de instrumentos de óptica y equipo fotográfico' },
    { code: '26800', description: 'Fabricación de medios magnéticos y ópticos' },
    { code: '27100', description: 'Fabricación de motores, generadores, transformadores eléctricos,aparatos de distribución y control de electricidad' },
    { code: '27200', description: 'Fabricación de pilas, baterías y acumuladores' },
    { code: '27310', description: 'Fabricación de cables de fibra óptica' },
    { code: '27320', description: 'Fabricación de otros hilos y cables eléctricos' },
    { code: '27330', description: 'Fabricación de dispositivos de cableados' },
    { code: '27400', description: 'Fabricación de equipo eléctrico de iluminación' },
    { code: '27500', description: 'Fabricación de aparatos de uso doméstico' },
    { code: '27900', description: 'Fabricación de otros tipos de equipo eléctrico' },
    { code: '28110', description: 'Fabricación de motores y turbinas, excepto motores paraaeronaves, vehículos automotores y motocicletas' },
    { code: '28120', description: 'Fabricación de equipo hidráulico' },
    { code: '28130', description: 'Fabricación de otras bombas, compresores, grifos y válvulas' },
    { code: '28140', description: 'Fabricación de cojinetes, engranajes, trenes de engranajes y piezasde transmisión' },
    { code: '28150', description: 'Fabricación de hornos y quemadores' },
    { code: '28160', description: 'Fabricación de equipo de elevación y manipulación' },
    { code: '28170', description: 'Fabricación de maquinaria y equipo de oficina' },
    { code: '28180', description: 'Fabricación de herramientas manuales' },
    { code: '28190', description: 'Fabricación de otros tipos de maquinaria de uso general' },
    { code: '28210', description: 'Fabricación de maquinaria agropecuaria y forestal' },
    { code: '28220', description: 'Fabricación de máquinas para conformar metales y maquinariaherramienta' },
    { code: '28230', description: 'Fabricación de maquinaria metalúrgica' },
    { code: '28240', description: 'Fabricación de maquinaria para la explotación de minas y canterasy para obras de construcción' },
    { code: '28250', description: 'Fabricación de maquinaria para la elaboración de alimentos,bebidas y tabaco' },
    { code: '28260', description: 'Fabricación de maquinaria para la elaboración de productostextiles, prendas de vestir y cueros' },
    { code: '28291', description: 'Fabricación de máquinas para imprenta' },
    { code: '28299', description: 'Fabricación de maquinaria de uso especial ncp' },
    { code: '29100', description: 'Fabricación vehículos automotores' },
    { code: '29200', description: 'Fabricación de carrocerías para vehículos automotores; fabricación de remolques y semiremolques' },
    { code: '29300', description: 'Fabricación de partes, piezas y accesorios para vehículosautomotores' },
    { code: '30110', description: 'Fabricación de buques' },
    { code: '30120', description: 'Construcción y reparación de embarcaciones de recreo' },
    { code: '30200', description: 'Fabricación de locomotoras y de material rodante' },
    { code: '30300', description: 'Fabricación de aeronaves y naves espaciales' },
    { code: '30400', description: 'Fabricación de vehículos militares de combate' },
    { code: '30910', description: 'Fabricación de motocicletas' },
    { code: '30920', description: 'Fabricación de bicicletas y sillones de ruedas para inválidos' },
    { code: '30990', description: 'Fabricación de equipo de transporte ncp' },
    { code: '31001', description: 'Fabricación de colchones y somier' },
    { code: '31002', description: 'Fabricación de muebles y otros productos de madera a medida' },
    { code: '31008', description: 'Servicios de maquilado de muebles' },
    { code: '31009', description: 'Fabricación de muebles ncp' },
    { code: '32110', description: 'Fabricación de joyas platerías y joyerías' },
    { code: '32120', description: 'Fabricación de joyas de imitación (fantasía) y artículos conexos' },
    { code: '32200', description: 'Fabricación de instrumentos musicales' },
    { code: '32301', description: 'Fabricación de artículos de deporte' },
    { code: '32308', description: 'Servicio de maquila de productos deportivos' },
    { code: '32401', description: 'Fabricación de juegos de mesa y de salón' },
    { code: '32402', description: 'Servicio de maquilado de juguetes y juegos' },
    { code: '32409', description: 'Fabricación de juegos y juguetes n.c.p.' },
    { code: '32500', description: 'Fabricación de instrumentos y materiales médicos y odontológicos' },
    { code: '32901', description: 'Fabricación de lápices, bolígrafos, sellos y artículos de librería engeneral' },
    { code: '32902', description: 'Fabricación de escobas, cepillos, pinceles y similares' },
    { code: '32903', description: 'Fabricación de artesanías de materiales diversos' },
    { code: '32904', description: 'Fabricación de artículos de uso personal y domésticos n.c.p.' },
    { code: '32905', description: 'Fabricación de accesorios para las confecciones y la marroquinerían.c.p.' },
    { code: '32908', description: 'Servicios de maquila ncp' },
    { code: '32909', description: 'Fabricación de productos manufacturados n.c.p.' },
    { code: '33110', description: 'Reparación y mantenimiento de productos elaborados de metal' },
    { code: '33120', description: 'Reparación y mantenimiento de maquinaria' },
    { code: '33130', description: 'Reparación y mantenimiento de equipo electrónico y óptico' },
    { code: '33140', description: 'Reparación y mantenimiento de equipo eléctrico' },
    { code: '33150', description: 'Reparación y mantenimiento de equipo de transporte, exceptovehículos automotores' },
    { code: '33190', description: 'Reparación y mantenimiento de equipos n.c.p.' },
    { code: '33200', description: 'Instalación de maquinaria y equipo industrial' },
    { code: '35101', description: 'Generación de energía eléctrica' },
    { code: '35102', description: 'Transmisión de energía eléctrica' },
    { code: '35103', description: 'Distribución de energía eléctrica' },
    { code: '35200', description: 'Fabricación de gas, distribución de combustibles gaseosos por tuberías' },
    { code: '35300', description: 'Suministro de vapor y agua caliente' },
    { code: '36000', description: 'Captación, tratamiento y suministro de agua' },
    { code: '37000', description: 'Evacuación de aguas residuales (alcantarillado)' },
    { code: '38110', description: 'Recolección y transporte de desechos sólidos proveniente de hogares y sector urbano' },
    { code: '38120', description: 'Recolección de desechos peligrosos' },
    { code: '38210', description: 'Tratamiento y eliminación de desechos inicuos' },
    { code: '38220', description: 'Tratamiento y eliminación de desechos peligrosos' },
    { code: '38301', description: 'Reciclaje de desperdicios y desechos textiles' },
    { code: '38302', description: 'Reciclaje de desperdicios y desechos de plástico y caucho' },
    { code: '38303', description: 'Reciclaje de desperdicios y desechos de vidrio' },
    { code: '38304', description: 'Reciclaje de desperdicios y desechos de papel y cartón' },
    { code: '38305', description: 'Reciclaje de desperdicios y desechos metálicos' },
    { code: '38309', description: 'Reciclaje de desperdicios y desechos no metálicos n.c.p.' },
    { code: '39000', description: 'Actividades de Saneamiento y otros Servicios de Gestión de Desechos' },
    { code: '41001', description: 'Construcción de edificios residenciales' },
    { code: '41002', description: 'Construcción de edificios no residenciales' },
    { code: '42100', description: 'Construcción de carreteras, calles y caminos' },
    { code: '42200', description: 'Construcción de proyectos de servicio público' },
    { code: '42900', description: 'Construcción de obras de ingeniería civil n.c.p.' },
    { code: '43110', description: 'Demolición' },
    { code: '43120', description: 'Preparación de terreno' },
    { code: '43210', description: 'Instalaciones eléctricas' },
    { code: '43220', description: 'Instalación de fontanería, calefacción y aire acondicionado' },
    { code: '43290', description: 'Otras instalaciones para obras de construcción' },
    { code: '43300', description: 'Terminación y acabado de edificios' },
    { code: '43900', description: 'Otras actividades especializadas de construcción' },
    { code: '43901', description: 'Fabricación de techos y materiales diversos' },
    { code: '45100', description: 'Venta de vehículos automotores' },
    { code: '45201', description: 'Reparación mecánica de vehículos automotores' },
    { code: '45202', description: 'Reparaciones eléctricas del automotor y recarga de baterías' },
    { code: '45203', description: 'Enderezado y pintura de vehículos automotores' },
    { code: '45204', description: 'Reparaciones de radiadores, escapes y silenciadores' },
    { code: '45205', description: 'Reparación y reconstrucción de vías, stop y otros artículos de fibra de vidrio' },
    { code: '45206', description: 'Reparación de llantas de vehículos automotores' },
    { code: '45207', description: 'Polarizado de vehículos (mediante la adhesión de papel especial a los vidrios)' },
    { code: '45208', description: 'Lavado y pasteado de vehículos (carwash)' },
    { code: '45209', description: 'Reparaciones de vehículos n.c.p.' },
    { code: '45211', description: 'Remolque de vehículos automotores' },
    { code: '45301', description: 'Venta de partes, piezas y accesorios nuevos para vehículos automotores' },
    { code: '45302', description: 'Venta de partes, piezas y accesorios usados para vehículos automotores' },
    { code: '45401', description: 'Venta de motocicletas' },
    { code: '45402', description: 'Venta de repuestos, piezas y accesorios de motocicletas' },
    { code: '45403', description: 'Mantenimiento y reparación de motocicletas' },
    { code: '46100', description: 'Venta al por mayor a cambio de retribución o por contrata' },
    { code: '46201', description: 'Venta al por mayor de materias primas agrícolas' },
    { code: '46202', description: 'Venta al por mayor de productos de la silvicultura' },
    { code: '46203', description: 'Venta al por mayor de productos pecuarios y de granja' },
    { code: '46211', description: 'Venta de productos para uso agropecuario' },
    { code: '46291', description: 'Venta al por mayor de granos básicos (cereales, leguminosas)' },
    { code: '46292', description: 'Venta al por mayor de semillas mejoradas para cultivo' },
    { code: '46293', description: 'Venta al por mayor de café oro y uva' },
    { code: '46294', description: 'Venta al por mayor de caña de azúcar' },
    { code: '46295', description: 'Venta al por mayor de flores, plantas y otros productos naturales' },
    { code: '46296', description: 'Venta al por mayor de productos agrícolas' },
    { code: '46297', description: 'Venta al por mayor de ganado bovino (vivo)' },
    { code: '46298', description: 'Venta al por mayor de animales porcinos, ovinos, caprinos, canículas, apícolas, avícolas vivos' },
    { code: '46299', description: 'Venta de otras especies vivas del reino animal' },
    { code: '46301', description: 'Venta al por mayor de alimentos' },
    { code: '46302', description: 'Venta al por mayor de bebidas' },
    { code: '46303', description: 'Venta al por mayor de tabaco' },
    { code: '46371', description: 'Venta al por mayor de frutas, hortalizas (verduras), legumbres y tubérculos' },
    { code: '46372', description: 'Venta al por mayor de pollos, gallinas destazadas, pavos y otras aves' },
    { code: '46373', description: 'Venta al por mayor de carne bovina y porcina, productos de carne y embutidos' },
    { code: '46374', description: 'Venta al por mayor de huevos' },
    { code: '46375', description: 'Venta al por mayor de productos lácteos' },
    { code: '46376', description: 'Venta al por mayor de productos farináceos de panadería (pan dulce, cakes, repostería, etc.)' },
    { code: '46377', description: 'Venta al por mayor de pastas alimenticias, aceites y grasas comestibles vegetal y animal' },
    { code: '46378', description: 'Venta al por mayor de sal comestible' },
    { code: '46379', description: 'Venta al por mayor de azúcar' },
    { code: '46391', description: 'Venta al por mayor de abarrotes (vinos, licores, productos alimenticios envasados, etc.)' },
    { code: '46392', description: 'Venta al por mayor de aguas gaseosas' },
    { code: '46393', description: 'Venta al por mayor de agua purificada' },
    { code: '46394', description: 'Venta al por mayor de refrescos y otras bebidas, líquidas o en polvo' },
    { code: '46395', description: 'Venta al por mayor de cerveza y licores' },
    { code: '46396', description: 'Venta al por mayor de hielo' },
    { code: '46411', description: 'Venta al por mayor de hilados, tejidos y productos textiles de mercería' },
    { code: '46412', description: 'Venta al por mayor de artículos textiles excepto confecciones para el hogar' },
    { code: '46413', description: 'Venta al por mayor de confecciones textiles para el hogar' },
    { code: '46414', description: 'Venta al por mayor de prendas de vestir y accesorios de vestir' },
    { code: '46415', description: 'Venta al por mayor de ropa usada' },
    { code: '46416', description: 'Venta al por mayor de calzado' },
    { code: '46417', description: 'Venta al por mayor de artículos de marroquinería y talabartería' },
    { code: '46418', description: 'Venta al por mayor de artículos de peletería' },
    { code: '46419', description: 'Venta al por mayor de otros artículos textiles n.c.p.' },
    { code: '46471', description: 'Venta al por mayor de instrumentos musicales' },
    { code: '46472', description: 'Venta al por mayor de colchones, almohadas, cojines, etc.' },
    { code: '46473', description: 'Venta al por mayor de artículos de aluminio para el hogar y para otros usos' },
    { code: '46474', description: 'Venta al por mayor de depósitos y otros artículos plásticos para el hogar y otros usos, incluyendo los desechables de durapax y no desechables' },
    { code: '46475', description: 'Venta al por mayor de cámaras fotográficas, accesorios y materiales' },
    { code: '46482', description: 'Venta al por mayor de medicamentos, artículos y otros productos de uso veterinario' },
    { code: '46483', description: 'Venta al por mayor de productos y artículos de belleza y de uso personal' },
    { code: '46484', description: 'Venta de productos farmacéuticos y medicinales' },
    { code: '46491', description: 'Venta al por mayor de productos medicinales, cosméticos, perfumería y productos de limpieza' },
    { code: '46492', description: 'Venta al por mayor de relojes y artículos de joyería' },
    { code: '46493', description: 'Venta al por mayor de electrodomésticos y artículos del hogar excepto bazar; artículos de iluminación' },
    { code: '46494', description: 'Venta al por mayor de artículos de bazar y similares' },
    { code: '46495', description: 'Venta al por mayor de artículos de óptica' },
    { code: '46496', description: 'Venta al por mayor de revistas, periódicos, libros, artículos de librería y artículos de papel y cartón en general' },
    { code: '46497', description: 'Venta de artículos deportivos, juguetes y rodados' },
    { code: '46498', description: 'Venta al por mayor de productos usados para el hogar o el uso personal' },
    { code: '46499', description: 'Venta al por mayor de enseres domésticos y de uso personal n.c.p.' },
    { code: '46500', description: 'Venta al por mayor de bicicletas, partes, accesorios y otros' },
    { code: '46510', description: 'Venta al por mayor de computadoras, equipo periférico y programas informáticos' },
    { code: '46520', description: 'Venta al por mayor de equipos de comunicación' },
    { code: '46530', description: 'Venta al por mayor de maquinaria y equipo agropecuario, accesorios, partes y suministros' },
    { code: '46590', description: 'Venta de equipos e instrumentos de uso profesional y científico y aparatos de medida y control' },
    { code: '46591', description: 'Venta al por mayor de maquinaria equipo, accesorios y materiales para la industria de la madera y sus productos' },
    { code: '46592', description: 'Venta al por mayor de maquinaria, equipo, accesorios y materiales para la industria gráfica y del papel, cartón y productos de papel y cartón' },
    { code: '46593', description: 'Venta al por mayor de maquinaria, equipo, accesorios y materiales para la industria de productos químicos, plástico y caucho' },
    { code: '46594', description: 'Venta al por mayor de maquinaria, equipo, accesorios y materiales para la industria metálica y de sus productos' },
    { code: '46595', description: 'Venta al por mayor de equipamiento para uso médico, odontológico, veterinario y servicios conexos' },
    { code: '46596', description: 'Venta al por mayor de maquinaria, equipo, accesorios y partes para la industria de la alimentación' },
    { code: '46597', description: 'Venta al por mayor de maquinaria, equipo, accesorios y partes para la industria textil, confecciones y cuero' },
    { code: '46598', description: 'Venta al por mayor de maquinaria, equipo y accesorios para la construcción y explotación de minas y canteras' },
    { code: '46599', description: 'Venta al por mayor de otro tipo de maquinaria y equipo con sus accesorios y partes' },
    { code: '46610', description: 'Venta al por mayor de otros combustibles sólidos, líquidos, gaseosos y de productos conexos' },
    { code: '46612', description: 'Venta al por mayor de combustibles para automotores, aviones, barcos, maquinaria y otros' },
    { code: '46613', description: 'Venta al por mayor de lubricantes, grasas y otros aceites para automotores, maquinaria industrial, etc.' },
    { code: '46614', description: 'Venta al por mayor de gas propano' },
    { code: '46615', description: 'Venta al por mayor de leña y carbón' },
    { code: '46620', description: 'Venta al por mayor de metales y minerales metalíferos' },
    { code: '46631', description: 'Venta al por mayor de puertas, ventanas, vitrinas y similares' },
    { code: '46632', description: 'Venta al por mayor de artículos de ferretería y pinturerías' },
    { code: '46633', description: 'Vidrierías' },
    { code: '46634', description: 'Venta al por mayor de maderas' },
    { code: '46639', description: 'Venta al por mayor de materiales para la construcción n.c.p.' },
    { code: '46691', description: 'Venta al por mayor de sal industrial sin yodar' },
    { code: '46692', description: 'Venta al por mayor de productos intermedios y desechos de origen textil' },
    { code: '46693', description: 'Venta al por mayor de productos intermedios y desechos de origen metálico' },
    { code: '46694', description: 'Venta al por mayor de productos intermedios y desechos de papel y cartón' },
    { code: '46695', description: 'Venta al por mayor fertilizantes, abonos, agroquímicos y productos similares' },
    { code: '46696', description: 'Venta al por mayor de productos intermedios y desechos de origen plástico' },
    { code: '46697', description: 'Venta al por mayor de tintas para imprenta, productos curtientes y materias y productos colorantes' },
    { code: '46698', description: 'Venta de productos intermedios y desechos de origen químico y de caucho' },
    { code: '46699', description: 'Venta al por mayor de productos intermedios y desechos ncp' },
    { code: '46701', description: 'Venta de algodón en oro' },
    { code: '46900', description: 'Venta al por mayor de otros productos' },
    { code: '46901', description: 'Venta al por mayor de cohetes y otros productos pirotécnicos' },
    { code: '46902', description: 'Venta al por mayor de artículos diversos para consumo humano' },
    { code: '46903', description: 'Venta al por mayor de armas de fuego, municiones y accesorios' },
    { code: '46904', description: 'Venta al por mayor de toldos y tiendas de campaña de cualquier material' },
    { code: '46905', description: 'Venta al por mayor de exhibidores publicitarios y rótulos' },
    { code: '46906', description: 'Venta al por mayor de artículos promocionales diversos' },
    { code: '47111', description: 'Venta en supermercados' },
    { code: '47112', description: 'Venta en tiendas de artículos de primera necesidad' },
    { code: '47119', description: 'Almacenes (venta de diversos artículos)' },
    { code: '47190', description: 'Venta al por menor de otros productos en comercios no especializados' },
    { code: '47199', description: 'Venta de establecimientos no especializados con surtido compuesto principalmente de alimentos, bebidas y tabaco' },
    { code: '47211', description: 'Venta al por menor de frutas y hortalizas' },
    { code: '47212', description: 'Venta al por menor de carnes, embutidos y productos de granja' },
    { code: '47213', description: 'Venta al por menor de pescado y mariscos' },
    { code: '47214', description: 'Venta al por menor de productos lácteos' },
    { code: '47215', description: 'Venta al por menor de productos de panadería, repostería y galletas' },
    { code: '47216', description: 'Venta al por menor de huevos' },
    { code: '47217', description: 'Venta al por menor de carnes y productos cárnicos' },
    { code: '47218', description: 'Venta al por menor de granos básicos y otros' },
    { code: '47219', description: 'Venta al por menor de alimentos n.c.p.' },
    { code: '47221', description: 'Venta al por menor de hielo' },
    { code: '47223', description: 'Venta de bebidas no alcohólicas, para su consumo fuera del establecimiento' },
    { code: '47224', description: 'Venta de bebidas alcohólicas, para su consumo fuera del establecimiento' },
    { code: '47225', description: 'Venta de bebidas alcohólicas para su consumo dentro del establecimiento' },
    { code: '47230', description: 'Venta al por menor de tabaco' },
    { code: '47300', description: 'Venta de combustibles, lubricantes y otros (gasolineras)' },
    { code: '47411', description: 'Venta al por menor de computadoras y equipo periférico' },
    { code: '47412', description: 'Venta de equipo y accesorios de telecomunicación' },
    { code: '47420', description: 'Venta al por menor de equipo de audio y video' },
    { code: '47510', description: 'Venta al por menor de hilados, tejidos y productos textiles de mercería; confecciones para el hogar y textiles n.c.p.' },
    { code: '47521', description: 'Venta al por menor de productos de madera' },
    { code: '47522', description: 'Venta al por menor de artículos de ferretería' },
    { code: '47523', description: 'Venta al por menor de productos de pinturerías' },
    { code: '47524', description: 'Venta al por menor en vidrierías' },
    { code: '47529', description: 'Venta al por menor de materiales de construcción y artículos conexos' },
    { code: '47530', description: 'Venta al por menor de tapices, alfombras y revestimientos de paredes y pisos en comercios especializados' },
    { code: '47591', description: 'Venta al por menor de muebles' },
    { code: '47592', description: 'Venta al por menor de artículos de bazar' },
    { code: '47593', description: 'Venta al por menor de aparatos electrodomésticos, repuestos y accesorios' },
    { code: '47594', description: 'Venta al por menor de artículos eléctricos y de iluminación' },
    { code: '47598', description: 'Venta al por menor de instrumentos musicales' },
    { code: '47610', description: 'Venta al por menor de libros, periódicos y artículos de papelería en comercios especializados' },
    { code: '47620', description: 'Venta al por menor de discos láser, cassettes, cintas de video y otros' },
    { code: '47630', description: 'Venta al por menor de productos y equipos de deporte' },
    { code: '47631', description: 'Venta al por menor de bicicletas, accesorios y repuestos' },
    { code: '47640', description: 'Venta al por menor de juegos y juguetes en comercios especializados' },
    { code: '47711', description: 'Venta al por menor de prendas de vestir y accesorios de vestir' },
    { code: '47712', description: 'Venta al por menor de calzado' },
    { code: '47713', description: 'Venta al por menor de artículos de peletería, marroquinería y talabartería' },
    { code: '47721', description: 'Venta al por menor de medicamentos farmacéuticos y otros materiales y artículos de uso médico, odontológico y veterinario' },
    { code: '47722', description: 'Venta al por menor de productos cosméticos y de tocador' },
    { code: '47731', description: 'Venta al por menor de productos de joyería, bisutería, óptica, relojería' },
    { code: '47732', description: 'Venta al por menor de plantas, semillas, animales y artículos conexos' },
    { code: '47733', description: 'Venta al por menor de combustibles de uso doméstico (gas propano y gas licuado)' },
    { code: '47734', description: 'Venta al por menor de artesanías, artículos cerámicos y recuerdos en general' },
    { code: '47735', description: 'Venta al por menor de ataúdes, lápidas y cruces, trofeos, artículos religiosos en general' },
    { code: '47736', description: 'Venta al por menor de armas de fuego, municiones y accesorios' },
    { code: '47737', description: 'Venta al por menor de artículos de cohetería y pirotécnicos' },
    { code: '47738', description: 'Venta al por menor de artículos desechables de uso personal y doméstico (servilletas, papel higiénico, pañales, toallas sanitarias,etc.)' },
    { code: '47739', description: 'Venta al por menor de otros productos n.c.p.' },
    { code: '47741', description: 'Venta al por menor de artículos usados' },
    { code: '47742', description: 'Venta al por menor de textiles y confecciones usados' },
    { code: '47743', description: 'Venta al por menor de libros, revistas, papel y cartón usados' },
    { code: '47749', description: 'Venta al por menor de productos usados n.c.p.' },
    { code: '47811', description: 'Venta al por menor de frutas, verduras y hortalizas' },
    { code: '47814', description: 'Venta al por menor de productos lácteos' },
    { code: '47815', description: 'Venta al por menor de productos de panadería, galletas y similares' },
    { code: '47816', description: 'Venta al por menor de bebidas' },
    { code: '47818', description: 'Venta al por menor en tiendas de mercado y puestos' },
    { code: '47821', description: 'Venta al por menor de hilados, tejidos y productos textiles de mercería en puestos de mercados y ferias' },
    { code: '47822', description: 'Venta al por menor de artículos textiles excepto confecciones para el hogar en puestos de mercados y ferias' },
    { code: '47823', description: 'Venta al por menor de confecciones textiles para el hogar en puestos de mercados y ferias' },
    { code: '47824', description: 'Venta al por menor de prendas de vestir, accesorios de vestir y similares en puestos de mercados y ferias' },
    { code: '47825', description: 'Venta al por menor de ropa usada' },
    { code: '47826', description: 'Venta al por menor de calzado, artículos de marroquinería y talabartería en puestos de mercados y ferias' },
    { code: '47827', description: 'Venta al por menor de artículos de marroquinería y talabartería en puestos de mercados y ferias' },
    { code: '47829', description: 'Venta al por menor de artículos textiles ncp en puestos de mercados y ferias' },
    { code: '47891', description: 'Venta al por menor de animales, flores y productos conexos en puestos de feria y mercados' },
    { code: '47892', description: 'Venta al por menor de productos medicinales, cosméticos, de tocador y de limpieza en puestos de ferias y mercados' },
    { code: '47893', description: 'Venta al por menor de artículos de bazar en puestos de ferias y mercados' },
    { code: '47894', description: 'Venta al por menor de artículos de papel, envases, libros, revistas y conexos en puestos de feria y mercados' },
    { code: '47895', description: 'Venta al por menor de materiales de construcción, electrodomésticos, accesorios para autos y similares en puestos de feria y mercados' },
    { code: '47896', description: 'Venta al por menor de equipos accesorios para las comunicaciones en puestos de feria y mercados' },
    { code: '47899', description: 'Venta al por menor en puestos de ferias y mercados n.c.p.' },
    { code: '47910', description: 'Venta al por menor por correo o Internet' },
    { code: '47990', description: 'Otros tipos de venta al por menor no realizada, en almacenes, puestos de venta o mercado' },
    { code: '49110', description: 'Transporte interurbano de pasajeros por ferrocarril' },
    { code: '49120', description: 'Transporte de carga por ferrocarril' },
    { code: '49211', description: 'Transporte de pasajeros urbanos e interurbano mediante buses' },
    { code: '49212', description: 'Transporte de pasajeros interdepartamental mediante microbuses' },
    { code: '49213', description: 'Transporte de pasajeros urbanos e interurbano mediante microbuses' },
    { code: '49214', description: 'Transporte de pasajeros interdepartamental mediante buses' },
    { code: '49221', description: 'Transporte internacional de pasajeros' },
    { code: '49222', description: 'Transporte de pasajeros mediante taxis y autos con chofer' },
    { code: '49223', description: 'Transporte escolar' },
    { code: '49225', description: 'Transporte de pasajeros para excursiones' },
    { code: '49226', description: 'Servicios de transporte de personal' },
    { code: '49229', description: 'Transporte de pasajeros por vía terrestre ncp' },
    { code: '49231', description: 'Transporte de carga urbano' },
    { code: '49232', description: 'Transporte nacional de carga' },
    { code: '49233', description: 'Transporte de carga internacional' },
    { code: '49234', description: 'Servicios de mudanza' },
    { code: '49235', description: 'Alquiler de vehículos de carga con conductor' },
    { code: '49300', description: 'Transporte por oleoducto o gasoducto' },
    { code: '50110', description: 'Transporte de pasajeros marítimo y de cabotaje' },
    { code: '50120', description: 'Transporte de carga marítimo y de cabotaje' },
    { code: '50211', description: 'Transporte de pasajeros por vías de navegación interiores' },
    { code: '50212', description: 'Alquiler de equipo de transporte de pasajeros por vías de navegación interior con conductor' },
    { code: '50220', description: 'Transporte de carga por vías de navegación interiores' },
    { code: '51100', description: 'Transporte aéreo de pasajeros' },
    { code: '51201', description: 'Transporte de carga por vía aérea' },
    { code: '51202', description: 'Alquiler de equipo de aerotransporte con operadores para el propósito de transportar carga' },
    { code: '52101', description: 'Alquiler de instalaciones de almacenamiento en zonas francas' },
    { code: '52102', description: 'Alquiler de silos para conservación y almacenamiento de granos' },
    { code: '52103', description: 'Alquiler de instalaciones con refrigeración para almacenamiento y conservación de alimentos y otros productos' },
    { code: '52109', description: 'Alquiler de bodegas para almacenamiento y depósito n.c.p.' },
    { code: '52211', description: 'Servicio de garaje y estacionamiento' },
    { code: '52212', description: 'Servicios de terminales para el transporte por vía terrestre' },
    { code: '52219', description: 'Servicios para el transporte por vía terrestre n.c.p.' },
    { code: '52220', description: 'Servicios para el transporte acuático' },
    { code: '52230', description: 'Servicios para el transporte aéreo' },
    { code: '52240', description: 'Manipulación de carga' },
    { code: '52290', description: 'Servicios para el transporte ncp' },
    { code: '52291', description: 'Agencias de tramitaciones aduanales' },
    { code: '53100', description: 'Servicios de correo nacional' },
    { code: '53200', description: 'Actividades de correo distintas a las actividades postales nacionales' },
    { code: '55101', description: 'Actividades de alojamiento para estancias cortas' },
    { code: '55102', description: 'Hoteles' },
    { code: '55200', description: 'Actividades de campamentos, parques de vehículos de recreo y parques de caravanas' },
    { code: '55900', description: 'Alojamiento n.c.p.' },
    { code: '56101', description: 'Restaurantes' },
    { code: '56106', description: 'Pupusería' },
    { code: '56107', description: 'Actividades varias de restaurantes' },
    { code: '56108', description: 'Comedores' },
    { code: '56109', description: 'Merenderos ambulantes' },
    { code: '56210', description: 'Preparación de comida para eventos especiales' },
    { code: '56291', description: 'Servicios de provisión de comidas por contrato' },
    { code: '56292', description: 'Servicios de concesión de cafetines y chalet en empresas e instituciones' },
    { code: '56299', description: 'Servicios de preparación de comidas ncp' },
    { code: '56301', description: 'Servicio de expendio de bebidas en salones y bares' },
    { code: '56302', description: 'Servicio de expendio de bebidas en puestos callejeros, mercados y ferias' },
    { code: '58110', description: 'Edición de libros, folletos, partituras y otras ediciones distintas a estas' },
    { code: '58120', description: 'Edición de directorios y listas de correos' },
    { code: '58130', description: 'Edición de periódicos, revistas y otras publicaciones periódicas' },
    { code: '58190', description: 'Otras actividades de edición' },
    { code: '58200', description: 'Edición de programas informáticos (software)' },
    { code: '59110', description: 'Actividades de producción cinematográfica' },
    { code: '59120', description: 'Actividades de post producción de películas, videos y programas de televisión' },
    { code: '59130', description: 'Actividades de distribución de películas cinematográficas, videos y programas de televisión' },
    { code: '59140', description: 'Actividades de exhibición de películas cinematográficas y cintas de video' },
    { code: '59200', description: 'Actividades de edición y grabación de música' },
    { code: '60100', description: 'Servicios de difusiones de radio' },
    { code: '60201', description: 'Actividades de programación y difusión de televisión abierta' },
    { code: '60202', description: 'Actividades de suscripción y difusión de televisión por cable y/o suscripción' },
    { code: '60299', description: 'Servicios de televisión, incluye televisión por cable' },
    { code: '60900', description: 'Programación y transmisión de radio y televisión' },
    { code: '61101', description: 'Servicio de telefonía' },
    { code: '61102', description: 'Servicio de Internet' },
    { code: '61103', description: 'Servicio de telefonía fija' },
    { code: '61109', description: 'Servicio de Internet n.c.p.' },
    { code: '61201', description: 'Servicios de telefonía celular' },
    { code: '61202', description: 'Servicios de Internet inalámbrico' },
    { code: '61209', description: 'Servicios de telecomunicaciones inalámbrico n.c.p.' },
    { code: '61301', description: 'Telecomunicaciones satelitales' },
    { code: '61309', description: 'Comunicación vía satélite n.c.p.' },
    { code: '61900', description: 'Actividades de telecomunicación n.c.p.' },
    { code: '62010', description: 'Programación informática' },
    { code: '62020', description: 'Consultorías y gestión de servicios informáticos' },
    { code: '62090', description: 'Otras actividades de tecnología de información y servicios de computadora' },
    { code: '63110', description: 'Procesamiento de datos y actividades relacionadas' },
    { code: '63120', description: 'Portales WEB' },
    { code: '63910', description: 'Servicios de Agencias de Noticias' },
    { code: '63990', description: 'Otros servicios de información n.c.p.' },
    { code: '64110', description: 'Servicios provistos por el Banco Central de El salvador' },
    { code: '64190', description: 'Bancos' },
    { code: '64192', description: 'Entidades dedicadas al envío de remesas' },
    { code: '64199', description: 'Otras entidades financieras' },
    { code: '64200', description: 'Actividades de sociedades de cartera' },
    { code: '64300', description: 'Fideicomisos, fondos y otras fuentes de financiamiento' },
    { code: '64910', description: 'Arrendamientos financieros' },
    { code: '64920', description: 'Asociaciones cooperativas de ahorro y crédito dedicadas a la intermediación financiera' },
    { code: '64921', description: 'Instituciones emisoras de tarjetas de crédito y otros' },
    { code: '64922', description: 'Tipos de crédito ncp' },
    { code: '64928', description: 'Prestamistas y casas de empeño' },
    { code: '64990', description: 'Actividades de servicios financieros, excepto la financiación de planes de seguros y de pensiones n.c.p.' },
    { code: '65110', description: 'Planes de seguros de vida' },
    { code: '65120', description: 'Planes de seguro excepto de vida' },
    { code: '65199', description: 'Seguros generales de todo tipo' },
    { code: '65200', description: 'Planes se seguro' },
    { code: '65300', description: 'Planes de pensiones' },
    { code: '66110', description: 'Administración de mercados financieros (Bolsa de Valores)' },
    { code: '66120', description: 'Actividades bursátiles (Corredores de Bolsa)' },
    { code: '66190', description: 'Actividades auxiliares de la intermediación financiera ncp' },
    { code: '66210', description: 'Evaluación de riesgos y daños' },
    { code: '66220', description: 'Actividades de agentes y corredores de seguros' },
    { code: '66290', description: 'Otras actividades auxiliares de seguros y fondos de pensiones' },
    { code: '66300', description: 'Actividades de administración de fondos' },
    { code: '68101', description: 'Servicio de alquiler y venta de lotes en cementerios' },
    { code: '68109', description: 'Actividades inmobiliarias realizadas con bienes propios o arrendados n.c.p.' },
    { code: '68200', description: 'Actividades Inmobiliarias Realizadas a Cambio de una Retribución opor Contrata' },
    { code: '69100', description: 'Actividades jurídicas' },
    { code: '69200', description: 'Actividades de contabilidad, teneduría de libros y auditoría; asesoramiento en materia de impuestos' },
    { code: '70100', description: 'Actividades de oficinas centrales de sociedades de cartera' },
    { code: '70200', description: 'Actividades de consultoría en gestión empresarial' },
    { code: '71101', description: 'Servicios de arquitectura y planificación urbana y servicios conexos' },
    { code: '71102', description: 'Servicios de ingeniería' },
    { code: '71103', description: 'Servicios de agrimensura, topografía, cartografía, prospección y geofísica y servicios conexos' },
    { code: '71200', description: 'Ensayos y análisis técnicos' },
    { code: '72100', description: 'Investigaciones y desarrollo experimental en el campo de las ciencias naturales y la ingeniería' },
    { code: '72199', description: 'Investigaciones científicas' },
    { code: '72200', description: 'Investigaciones y desarrollo experimental en el campo de las ciencias sociales y las humanidades científica y desarrollo' },
    { code: '73100', description: 'Publicidad' },
    { code: '73200', description: 'Investigación de mercados y realización de encuestas de opinión pública' },
    { code: '74100', description: 'Actividades de diseño especializado' },
    { code: '74200', description: 'Actividades de fotografía' },
    { code: '74900', description: 'Servicios profesionales y científicos ncp' },
    { code: '75000', description: 'Actividades veterinarias' },
    { code: '77101', description: 'Alquiler de equipo de transporte terrestre' },
    { code: '77102', description: 'Alquiler de equipo de transporte acuático' },
    { code: '77103', description: 'Alquiler de equipo de transporte por vía aérea' },
    { code: '77210', description: 'Alquiler y arrendamiento de equipo de recreo y deportivo' },
    { code: '77220', description: 'Alquiler de cintas de video y discos' },
    { code: '77290', description: 'Alquiler de otros efectos personales y enseres domésticos' },
    { code: '77300', description: 'Alquiler de maquinaria y equipo' },
    { code: '77400', description: 'Arrendamiento de productos de propiedad intelectual' },
    { code: '78100', description: 'Obtención y dotación de personal' },
    { code: '78200', description: 'Actividades de las agencias de trabajo temporal' },
    { code: '78300', description: 'Dotación de recursos humanos y gestión; gestión de las funciones de recursos humanos' },
    { code: '79110', description: 'Actividades de agencias de viajes y organizadores de viajes; actividades de asistencia a turistas' },
    { code: '79120', description: 'Actividades de los operadores turísticos' },
    { code: '79900', description: 'Otros servicios de reservas y actividades relacionadas' },
    { code: '80100', description: 'Servicios de seguridad privados' },
    { code: '80201', description: 'Actividades de servicios de sistemas de seguridad' },
    { code: '80202', description: 'Actividades para la prestación de sistemas de seguridad' },
    { code: '80300', description: 'Actividades de investigación' },
    { code: '81100', description: 'Actividades combinadas de mantenimiento de edificios e instalaciones' },
    { code: '81210', description: 'Limpieza general de edificios' },
    { code: '81290', description: 'Otras actividades combinadas de mantenimiento de edificios e instalaciones ncp' },
    { code: '81300', description: 'Servicio de jardinería' },
    { code: '82110', description: 'Servicios administrativos de oficinas' },
    { code: '82190', description: 'Servicio de fotocopiado y similares, excepto en imprentas' },
    { code: '82200', description: 'Actividades de las centrales de llamadas (call center)' },
    { code: '82300', description: 'Organización de convenciones y ferias de negocios' },
    { code: '82910', description: 'Actividades de agencias de cobro y oficinas de crédito' },
    { code: '82921', description: 'Servicios de envase y empaque de productos alimenticios' },
    { code: '82922', description: 'Servicios de envase y empaque de productos medicinales' },
    { code: '82929', description: 'Servicio de envase y empaque ncp' },
    { code: '82990', description: 'Actividades de apoyo empresariales ncp' },
    { code: '84110', description: 'Actividades de la Administración Pública en general' },
    { code: '84111', description: 'Alcaldías municipales' },
    { code: '84120', description: 'Regulación de las actividades de prestación de servicios sanitarios, educativos, culturales y otros servicios sociales, excepto seguridad social' },
    { code: '84130', description: 'Regulación y facilitación de la actividad económica' },
    { code: '84210', description: 'Actividades de administración y funcionamiento del Ministerio de Relaciones Exteriores' },
    { code: '84220', description: 'Actividades de defensa' },
    { code: '84230', description: 'Actividades de mantenimiento del orden público y de seguridad' },
    { code: '84300', description: 'Actividades de planes de seguridad social de afiliación obligatoria' },
    { code: '85101', description: 'Guardería educativa' },
    { code: '85102', description: 'Enseñanza preescolar o parvularia' },
    { code: '85103', description: 'Enseñanza primaria' },
    { code: '85104', description: 'Servicio de educación preescolar y primaria integrada' },
    { code: '85211', description: 'Enseñanza secundaria tercer ciclo (7°, 8° y 9°)' },
    { code: '85212', description: 'Enseñanza secundaria de formación general bachillerato' },
    { code: '85221', description: 'Enseñanza secundaria de formación técnica y profesional' },
    { code: '85222', description: 'Enseñanza secundaria de formación técnica y profesional integrada con enseñanza primaria' },
    { code: '85301', description: 'Enseñanza superior universitaria' },
    { code: '85302', description: 'Enseñanza superior no universitaria' },
    { code: '85303', description: 'Enseñanza superior integrada a educación secundaria y/o primaria' },
    { code: '85410', description: 'Educación deportiva y recreativa' },
    { code: '85420', description: 'Educación cultural' },
    { code: '85490', description: 'Otros tipos de enseñanza n.c.p.' },
    { code: '85499', description: 'Enseñanza formal' },
    { code: '85500', description: 'Servicios de apoyo a la enseñanza' },
    { code: '86100', description: 'Actividades de hospitales' },
    { code: '86201', description: 'Clínicas médicas' },
    { code: '86202', description: 'Servicios de Odontología' },
    { code: '86203', description: 'Servicios médicos' },
    { code: '86901', description: 'Servicios de análisis y estudios de diagnóstico' },
    { code: '86902', description: 'Actividades de atención de la salud humana' },
    { code: '86909', description: 'Otros Servicio relacionados con la salud ncp' },
    { code: '87100', description: 'Residencias de ancianos con atención de enfermería' },
    { code: '87200', description: 'Instituciones dedicadas al tratamiento del retraso mental, problemas de salud mental y el uso indebido de sustancias nocivas' },
    { code: '87300', description: 'Instituciones dedicadas al cuidado de ancianos y discapacitados' },
    { code: '87900', description: 'Actividades de asistencia a niños y jóvenes' },
    { code: '87901', description: 'Otras actividades de atención en instituciones' },
    { code: '88100', description: 'Actividades de asistencia sociales sin alojamiento para ancianos y discapacitados' },
    { code: '88900', description: 'Servicios sociales sin alojamiento ncp' },
    { code: '90000', description: 'Actividades creativas artísticas y de esparcimiento' },
    { code: '91010', description: 'Actividades de bibliotecas y archivos' },
    { code: '91020', description: 'Actividades de museos y preservación de lugares y edificios históricos' },
    { code: '91030', description: 'Actividades de jardines botánicos, zoológicos y de reservas naturales' },
    { code: '92000', description: 'Actividades de juegos y apuestas' },
    { code: '93110', description: 'Gestión de instalaciones deportivas' },
    { code: '93120', description: 'Actividades de clubes deportivos' },
    { code: '93190', description: 'Otras actividades deportivas' },
    { code: '93210', description: 'Actividades de parques de atracciones y parques temáticos' },
    { code: '93291', description: 'Discotecas y salas de baile' },
    { code: '93298', description: 'Centros vacacionales' },
    { code: '93299', description: 'Actividades de esparcimiento ncp' },
    { code: '94110', description: 'Actividades de organizaciones empresariales y de empleadores' },
    { code: '94120', description: 'Actividades de organizaciones profesionales' },
    { code: '94200', description: 'Actividades de sindicatos' },
    { code: '94910', description: 'Actividades de organizaciones religiosas' },
    { code: '94920', description: 'Actividades de organizaciones políticas' },
    { code: '94990', description: 'Actividades de asociaciones n.c.p.' },
    { code: '95110', description: 'Reparación de computadoras y equipo periférico' },
    { code: '95120', description: 'Reparación de equipo de comunicación' },
    { code: '95210', description: 'Reparación de aparatos electrónicos de consumo' },
    { code: '95220', description: 'Reparación de aparatos doméstico y equipo de hogar y jardín' },
    { code: '95230', description: 'Reparación de calzado y artículos de cuero' },
    { code: '95240', description: 'Reparación de muebles y accesorios para el hogar' },
    { code: '95291', description: 'Reparación de Instrumentos musicales' },
    { code: '95292', description: 'Servicios de cerrajería y copiado de llaves' },
    { code: '95293', description: 'Reparación de joyas y relojes' },
    { code: '95294', description: 'Reparación de bicicletas, sillas de ruedas y rodados n.c.p.' },
    { code: '95299', description: 'Reparaciones de enseres personales n.c.p.' },
    { code: '96010', description: 'Lavado y limpieza de prendas de tela y de piel, incluso la limpieza en seco' },
    { code: '96020', description: 'Peluquería y otros tratamientos de belleza' },
    { code: '96030', description: 'Pompas fúnebres y actividades conexas' },
    { code: '96091', description: 'Servicios de sauna y otros servicios para la estética corporal n.c.p.' },
    { code: '96092', description: 'Servicios n.c.p.' },
    { code: '97000', description: 'Actividad de los hogares en calidad de empleadores de personal doméstico' },
    { code: '98100', description: 'Actividades indiferenciadas de producción de bienes de los hogares privados para uso propio' },
    { code: '98200', description: 'Actividades indiferenciadas de producción de servicios de los hogares privados para uso propio' },
    { code: '99000', description: 'Actividades de organizaciones y órganos extraterritoriales' },
];

// REEMPLAZA TU ClientForm ACTUAL CON ESTE
const ClientForm = ({ user, setUser, handleSubmit, handleCancel, isSaving, isEditMode }) => {
    const handleFormChange = (e) => { setUser({...user, [e.target.name]: e.target.value}); };
    const handleGiroChange = (e) => {
        const selectedCode = e.target.value;
        const selectedActivity = actividadesEconomicas.find(act => act.code === selectedCode) || { description: '' };
        setUser({ ...user, codigo_giro: selectedCode, giro_comercial: selectedActivity.description });
    };

    // Estilo base para todos los inputs, selects y textareas
    const inputStyle = "w-full p-2 border border-gray-300 rounded-lg mt-1 bg-gray-50 focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-all";

    return (
         <div className="bg-white border border-gray-200 p-6 sm:p-8 rounded-2xl shadow-sm">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">{isEditMode ? `Editando: ${user.name}` : 'Agregar Nuevo Cliente'}</h2>
            <form onSubmit={handleSubmit} className="space-y-8">
                {/* Sección de Información General */}
                <div>
                    <h3 className="text-lg font-semibold text-gray-700 border-b pb-2 mb-4">Información General</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                       <div><label className="block text-sm font-medium text-gray-700">Nombre / Razón Social</label><input type="text" name="name" value={user.name || ''} onChange={handleFormChange} className={inputStyle} required /></div>
                       <div><label className="block text-sm font-medium text-gray-700">Tipo de Cliente</label><select name="tipo_cliente" value={user.tipo_cliente || 'juridico'} onChange={handleFormChange} className={inputStyle}><option value="juridico">Jurídica</option><option value="natural">Persona Natural</option></select></div>
                       <div><label className="block text-sm font-medium text-gray-700">Estado</label><select name="estado" value={user.estado || 'activo'} onChange={handleFormChange} className={inputStyle}><option value="activo">Activo</option><option value="inactivo">Inactivo</option><option value="prospecto">Prospecto</option></select></div>
                       <div><label className="block text-sm font-medium text-gray-700">NIT</label><input type="text" name="nit" value={user.nit || ''} onChange={handleFormChange} className={inputStyle} /></div>
                       <div><label className="block text-sm font-medium text-gray-700">NRC</label><input type="text" name="nrc" value={user.nrc || ''} onChange={handleFormChange} className={inputStyle} /></div>
                       <div><label className="block text-sm font-medium text-gray-700">Código de Act. Económica</label><select name="codigo_giro" value={user.codigo_giro || ''} onChange={handleGiroChange} className={inputStyle}><option value="">-- Seleccione un código --</option>{actividadesEconomicas.map(act => (<option key={act.code} value={act.code}>{act.code} - {act.description.substring(0, 40)}...</option>))}</select></div>
                       <div className="md:col-span-3"><label className="block text-sm font-medium text-gray-700">Giro Comercial (Autocompletado)</label><input type="text" name="giro_comercial" value={user.giro_comercial || ''} className={`${inputStyle} bg-gray-200`} readOnly /></div>
                    </div>
                </div>

                {/* Sección de Datos de Contacto */}
                <div>
                    <h3 className="text-lg font-semibold text-gray-700 border-b pb-2 mb-4">Datos de Contacto</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                       <div><label className="block text-sm font-medium text-gray-700">Correo Principal</label><input type="email" name="correo_principal" value={user.correo_principal || ''} onChange={handleFormChange} className={inputStyle} /></div>
                       <div><label className="block text-sm font-medium text-gray-700">Correo Contable</label><input type="email" name="correo_contable" value={user.correo_contable || ''} onChange={handleFormChange} className={inputStyle} /></div>
                       <div><label className="block text-sm font-medium text-gray-700">Teléfono Móvil</label><input type="text" name="telefono_movil" value={user.telefono_movil || ''} onChange={handleFormChange} className={inputStyle} /></div>
                       <div><label className="block text-sm font-medium text-gray-700">Teléfono Fijo</label><input type="text" name="telefono_fijo" value={user.telefono_fijo || ''} onChange={handleFormChange} className={inputStyle} /></div>
                       <div><label className="block text-sm font-medium text-gray-700">Persona de Contacto</label><input type="text" name="nombre_contacto" value={user.nombre_contacto || ''} onChange={handleFormChange} className={inputStyle} /></div>
                       <div><label className="block text-sm font-medium text-gray-700">Cargo del Contacto</label><input type="text" name="cargo" value={user.cargo || ''} onChange={handleFormChange} className={inputStyle} /></div>
                       <div className="md:col-span-1"><label className="block text-sm font-medium text-gray-700">Dirección Fiscal</label><textarea name="direccion_fiscal" value={user.direccion_fiscal || ''} onChange={handleFormChange} className={inputStyle} rows="2"></textarea></div>
                       <div className="md:col-span-1"><label className="block text-sm font-medium text-gray-700">Dirección de Entrega</label><textarea name="direccion_entrega" value={user.direccion_entrega || ''} onChange={handleFormChange} className={inputStyle} rows="2"></textarea></div>
                    </div>
                </div>
                
                {/* Botones de Acción */}
                <div className="flex justify-end space-x-4 pt-4 border-t">
                    <button type="button" onClick={handleCancel} className="bg-gray-200 text-gray-800 font-bold py-2 px-5 rounded-lg hover:bg-gray-300 transition-all">Cancelar</button>
                    <button type="submit" className="bg-teal-500 text-white font-bold py-2 px-5 rounded-lg hover:bg-teal-600 disabled:bg-gray-400 transition-all" disabled={isSaving}>
                        {isSaving ? 'Guardando...' : 'Guardar Cliente'}
                    </button>
                </div>
            </form>
        </div>
    );
};
// REEMPLAZA TU ClientDatabaseComponent CON ESTA VERSIÓN LIMPIA
const ClientDatabaseComponent = ({ db, allUsers, userRole, userPermissions, logAction }) => {
    const [view, setView] = useState('list');
    const [editingUser, setEditingUser] = useState(null);
    const [newClient, setNewClient] = useState(getInitialClientState());
    const [isSaving, setIsSaving] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    function getInitialClientState() {
        return { name: '', tipo_cliente: 'juridico', estado: 'activo' };
    }

    const handleEditClick = (user) => {
        setEditingUser({ ...user });
        setView('edit');
    };

    const handleUpdateClient = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        const userDocRef = doc(db, 'artifacts', 'logicstrack-app', 'users', editingUser.id);
        try {
            const { id, uid, ...userDataToSave } = editingUser;
            await updateDoc(userDocRef, userDataToSave);
            await logAction('CLIENT_UPDATED', { clientId: editingUser.id, clientName: editingUser.name });
            setView('list');
            setEditingUser(null);
        } catch (error) { console.error("Error al actualizar cliente:", error); } 
        finally { setIsSaving(false); }
    };
    
    const handleAddNewClient = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        try {
            const manualId = `manual_${Date.now()}`;
            const clientData = { ...newClient, uid: manualId, id: manualId, fecha_creacion: new Date().toISOString().split('T')[0] };
            const newDocRef = doc(db, 'artifacts', 'logicstrack-app', 'users', manualId);
            await setDoc(newDocRef, clientData);
            setNewClient(getInitialClientState());
            setView('list');
        } catch (error) { console.error("Error al agregar cliente:", error); } 
        finally { setIsSaving(false); }
    };
    
    if (view === 'add') {
        return <ClientForm user={newClient} setUser={setNewClient} handleSubmit={handleAddNewClient} handleCancel={() => setView('list')} isSaving={isSaving} isEditMode={false} />;
    }
    
    if (view === 'edit' && editingUser) {
        return <ClientForm user={editingUser} setUser={setEditingUser} handleSubmit={handleUpdateClient} handleCancel={() => setView('list')} isSaving={isSaving} isEditMode={true} />;
    }

    // --- LÍNEA MODIFICADA ---
    // Ahora filtramos primero para excluir a los administradores y luego aplicamos la búsqueda.
    const filteredUsers = allUsers
        .filter(user => !user.permissions?.isAdmin) // <-- ESTE ES EL CAMBIO
        .filter(user => 
            (user.name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
            (user.email?.toLowerCase() || '').includes(searchTerm.toLowerCase())
        );

    const statusStyles = {
        activo: 'bg-green-100 text-green-800',
        inactivo: 'bg-gray-100 text-gray-800',
        prospecto: 'bg-yellow-100 text-yellow-800',
    };

    return (
        <div className="space-y-6">
            <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-4">
                <div>
                    <h2 className="text-3xl font-bold text-gray-800">Base de Datos de Clientes</h2>
                    <p className="text-gray-500 mt-1">Busca, visualiza y edita la información de tus clientes.</p>
                </div>
                <button onClick={() => setView('add')} className="bg-teal-500 text-white font-bold py-2 px-5 rounded-lg shadow-sm hover:bg-teal-600">
                    + Agregar Cliente
                </button>
            </div>

            <div className="bg-white border border-gray-200 p-5 rounded-2xl shadow-sm">
                <div className="relative mb-4">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" /></svg>
                    </div>
                    <input type="text" placeholder="Buscar por nombre o correo de cliente..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full p-2 pl-10 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-teal-500"/>
                </div>

                {filteredUsers.length > 0 ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                        {filteredUsers.map(user => (
                            <div key={user.id} className="border border-gray-200 bg-gray-50/50 p-4 rounded-xl flex flex-col justify-between">
                                <div>
                                    <div className="flex justify-between items-start">
                                        <h3 className="font-bold text-lg text-gray-800 truncate" title={user.name}>{user.name}</h3>
                                        <span className={`px-2.5 py-0.5 text-xs font-medium rounded-full ${statusStyles[user.estado] || 'bg-gray-100 text-gray-800'}`}>
                                            {user.estado?.charAt(0).toUpperCase() + user.estado?.slice(1)}
                                        </span>
                                    </div>
                                    <p className="text-sm text-gray-500 truncate" title={user.correo_principal || user.email}>{user.correo_principal || user.email}</p>
                                    <p className="text-sm text-gray-500">Tel: {user.telefono_movil || 'No disponible'}</p>
                                </div>
                                <div className="mt-4 pt-4 border-t border-gray-200 text-right">
                                    <button onClick={() => handleEditClick(user)} className="bg-blue-500 text-white text-xs font-bold py-1.5 px-4 rounded-full hover:bg-blue-600 transition-colors">
                                        Editar
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-10"><p className="text-gray-500">No se encontraron clientes que coincidan con la búsqueda.</p></div>
                )}
            </div>
        </div>
    );
};
// Componente del Panel de Administración
// --- REEMPLAZA TU AdminPanelComponent CON ESTA VERSIÓN FINAL Y COMPLETA ---
const AdminPanelComponent = ({ db }) => {
    // --- ESTADOS UNIFICADOS ---
    const [slaConfig, setSlaConfig] = useState({ maritimo: {}, aereo: {}, terrestre: {} });
    const [adminRates, setAdminRates] = useState({ maritimo: { routes: {} }, aereo: { routes: {} }, terrestre: { ftl: {}, ltl: {} } });
    const [adminAranceles, setAdminAranceles] = useState({ General: {}, Peligrosa: {}, Refrigerada: {} });
    const [isSaving, setIsSaving] = useState(false);

    // --- USE EFFECT PARA CARGAR TODA LA CONFIGURACIÓN ---
    useEffect(() => {
        const appId = 'logicstrack-app';
        const slaDocRef = doc(db, 'artifacts', appId, 'public', 'data', 'slaConfig', 'main');
        const ratesDocRef = doc(db, 'artifacts', appId, 'public', 'data', 'ratesConfig', 'main');
        const arancelesDocRef = doc(db, 'artifacts', appId, 'public', 'data', 'arancelesConfig', 'main');

        const unsubSla = onSnapshot(slaDocRef, (docSnap) => {
            if (docSnap.exists()) setSlaConfig(prev => ({ ...prev, ...docSnap.data() }));
        });
        const unsubRates = onSnapshot(ratesDocRef, (docSnap) => {
            if (docSnap.exists()) setAdminRates(prev => ({ ...prev, ...docSnap.data() }));
        });
        const unsubAranceles = onSnapshot(arancelesDocRef, (docSnap) => {
            if (docSnap.exists()) setAdminAranceles(prev => ({ ...prev, ...docSnap.data() }));
        });

        return () => {
            unsubSla();
            unsubRates();
            unsubAranceles();
        };
    }, [db]);

    // --- MANEJADOR DE CAMBIOS GENÉRICO ---
    const handleNestedChange = (setter, path, value) => {
        const keys = path.split('.');
        setter(prev => {
            const newState = JSON.parse(JSON.stringify(prev));
            let current = newState;
            for (let i = 0; i < keys.length - 1; i++) {
                current = current[keys[i]] = current[keys[i]] || {};
            }
            const finalValue = (typeof value === 'string' && !isNaN(parseFloat(value))) ? parseFloat(value) : value;
            current[keys[keys.length - 1]] = finalValue;
            return newState;
        });
    };
    
    // --- FUNCIÓN DE GUARDADO UNIFICADA ---
    const handleSaveConfigs = async () => {
        if (!db) return;
        setIsSaving(true);
        const appId = 'logicstrack-app';
        try {
            await setDoc(doc(db, 'artifacts', appId, 'public', 'data', 'slaConfig', 'main'), slaConfig, { merge: true });
            await setDoc(doc(db, 'artifacts', appId, 'public', 'data', 'ratesConfig', 'main'), adminRates, { merge: true });
            await setDoc(doc(db, 'artifacts', appId, 'public', 'data', 'arancelesConfig', 'main'), adminAranceles, { merge: true });
            alert("¡Toda la configuración ha sido guardada con éxito!");
        } catch (err) {
            console.error("Error saving configs:", err);
            alert("Error al guardar la configuración.");
        } finally {
            setIsSaving(false);
        }
    };

    const inputStyle = "w-full p-2 border border-gray-300 rounded-lg mt-1 bg-gray-50 focus:ring-2 focus:ring-teal-500";
    
    return (
        <div className="space-y-6">
            <div>
                <h2 className="text-3xl font-bold text-gray-800">Panel de Administración General</h2>
                <p className="text-gray-500 mt-1">Gestiona los parámetros clave de la operación de tu aplicación.</p>
            </div>
            
            <div className="space-y-6">
                {/* Tarjeta para Metas (SLAs) */}
                <div className="bg-white border border-gray-200 p-6 rounded-2xl shadow-sm">
                    <h3 className="text-xl font-bold text-gray-800 mb-4">⏱️ Metas de Rendimiento (SLAs)</h3>
                    <div className="space-y-6">
                        {/* Marítimo */}
                        <div>
                            <h4 className="font-semibold text-gray-700">🚢 Marítimo</h4>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-2">
                                <div><label className="text-sm">Lead Time FCL (días)</label><input type="number" value={slaConfig.maritimo?.leadTime || ''} onChange={e => handleNestedChange(setSlaConfig, 'maritimo.leadTime', e.target.value)} className={inputStyle} /></div>
                                <div><label className="text-sm">Aduana FCL (días)</label><input type="number" value={slaConfig.maritimo?.customsTime || ''} onChange={e => handleNestedChange(setSlaConfig, 'maritimo.customsTime', e.target.value)} className={inputStyle} /></div>
                                <div><label className="text-sm">Lead Time LCL (días)</label><input type="number" value={slaConfig.maritimo?.leadTimeConsolidado || ''} onChange={e => handleNestedChange(setSlaConfig, 'maritimo.leadTimeConsolidado', e.target.value)} className={inputStyle} /></div>
                                <div><label className="text-sm">Aduana LCL (días)</label><input type="number" value={slaConfig.maritimo?.customsTimeConsolidado || ''} onChange={e => handleNestedChange(setSlaConfig, 'maritimo.customsTimeConsolidado', e.target.value)} className={inputStyle} /></div>
                            </div>
                        </div>
                        {/* Aéreo */}
                        <div className="border-t pt-4">
                            <h4 className="font-semibold text-gray-700">✈️ Aéreo</h4>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
                                <div><label className="text-sm">Lead Time (días)</label><input type="number" value={slaConfig.aereo?.leadTime || ''} onChange={e => handleNestedChange(setSlaConfig, 'aereo.leadTime', e.target.value)} className={inputStyle} /></div>
                                <div><label className="text-sm">Tiempo en Aduana (días)</label><input type="number" value={slaConfig.aereo?.customsTime || ''} onChange={e => handleNestedChange(setSlaConfig, 'aereo.customsTime', e.target.value)} className={inputStyle} /></div>
                            </div>
                        </div>
                        {/* Terrestre */}
                        <div className="border-t pt-4">
                             <h4 className="font-semibold text-gray-700">🚚 Terrestre</h4>
                             <div className="space-y-4 mt-2">
                                {Object.keys(slaConfig.terrestre || {}).map((pais) => (
                                     <div key={pais} className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
                                        <label className="font-medium text-gray-700 capitalize">{pais}</label>
                                        <div><label className="block text-xs">Lead Time (días)</label><input type="number" value={slaConfig.terrestre[pais]?.leadTime || ''} onChange={e => handleNestedChange(setSlaConfig, `terrestre.${pais}.leadTime`, e.target.value)} className={inputStyle} /></div>
                                        <div><label className="block text-xs">Tiempo en Aduana (días)</label><input type="number" value={slaConfig.terrestre[pais]?.customsTime || ''} onChange={e => handleNestedChange(setSlaConfig, `terrestre.${pais}.customsTime`, e.target.value)} className={inputStyle} /></div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Tarjeta para Tarifas de Pre-Cotizador */}
                <div className="bg-white border border-gray-200 p-6 rounded-2xl shadow-sm">
                    <h3 className="text-xl font-bold text-gray-800 mb-4">💲 Tarifas de Pre-Cotizador</h3>
                    <div className="space-y-6">
                       {/* Marítimo */}
                        <div>
                            <h4 className="font-semibold text-gray-700">🚢 Marítimo (Rutas Principales)</h4>
                            <div className="space-y-2 mt-2">
                                {Object.keys(adminRates.maritimo?.routes || {}).map(route => (
                                    <div key={route} className="grid grid-cols-1 md:grid-cols-3 gap-4 p-2 bg-gray-50 rounded-md">
                                        <span className="font-medium text-gray-600">{route.replace(/_/g, ' ')}</span>
                                        <div><label className="text-xs">Tarifa FCL 40HC ($)</label><input type="number" value={adminRates.maritimo.routes[route]?.fcl['40HC'] || ''} onChange={e => handleNestedChange(setAdminRates, `maritimo.routes.${route}.fcl.40HC`, e.target.value)} className={inputStyle} /></div>
                                        <div><label className="text-xs">Tarifa por M³ LCL ($)</label><input type="number" value={adminRates.maritimo.routes[route]?.lcl.tarifaPorM3 || ''} onChange={e => handleNestedChange(setAdminRates, `maritimo.routes.${route}.lcl.tarifaPorM3`, e.target.value)} className={inputStyle} /></div>
                                    </div>
                                ))}
                            </div>
                        </div>
                         {/* Aéreo */}
                        <div className="border-t pt-4">
                            <h4 className="font-semibold text-gray-700">✈️ Aéreo (Rutas Principales)</h4>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-2">
                                {Object.keys(adminRates.aereo?.routes || {}).map(route => (
                                    <div key={route}>
                                        <label className="text-sm font-medium">{route.replace(/_/g, ' ')} ($/Kg)</label>
                                        <input type="number" value={adminRates.aereo.routes[route]?.tarifaPorKg || ''} onChange={e => handleNestedChange(setAdminRates, `aereo.routes.${route}.tarifaPorKg`, e.target.value)} className={inputStyle} />
                                    </div>
                                ))}
                            </div>
                        </div>
                        {/* Terrestre */}
                        <div className="border-t pt-4">
                            <h4 className="font-semibold text-gray-700">🚚 Terrestre</h4>
                            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mt-2">
                                {Object.keys(adminRates.terrestre?.ftl || {}).map(tipo => (
                                    <div key={tipo}><label className="text-sm capitalize">{tipo} (FTL)</label><input type="number" value={adminRates.terrestre.ftl[tipo] || ''} onChange={e => handleNestedChange(setAdminRates, `terrestre.ftl.${tipo}`, e.target.value)} className={inputStyle} /></div>
                                ))}
                                <div><label className="text-sm">Tarifa por Kg (LTL)</label><input type="number" value={adminRates.terrestre?.ltl?.tarifaPorKg || ''} onChange={e => handleNestedChange(setAdminRates, 'terrestre.ltl.tarifaPorKg', e.target.value)} className={inputStyle} /></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Tarjeta para Aranceles */}
                <div className="bg-white border border-gray-200 p-6 rounded-2xl shadow-sm">
                     <h3 className="text-xl font-bold text-gray-800 mb-4">🧾 Aranceles de Carga (%)</h3>
                     <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                         {Object.keys(adminAranceles).map(tipo => (
                             <div key={tipo} className="p-4 bg-gray-50 rounded-lg">
                                 <h4 className="font-semibold text-gray-700 mb-2">{tipo}</h4>
                                 <div className="space-y-2">
                                     <div><label className="text-sm font-medium text-gray-600">Arancel (%)</label><input type="number" value={(adminAranceles[tipo]?.arancel || 0) * 100} onChange={e => handleNestedChange(setAdminAranceles, `${tipo}.arancel`, parseFloat(e.target.value) / 100)} className={inputStyle} /></div>
                                     <div><label className="text-sm font-medium text-gray-600">IVA (%)</label><input type="number" value={(adminAranceles[tipo]?.iva || 0) * 100} onChange={e => handleNestedChange(setAdminAranceles, `${tipo}.iva`, parseFloat(e.target.value) / 100)} className={inputStyle} /></div>
                                 </div>
                             </div>
                         ))}
                     </div>
                 </div>
            </div>
            
            <div className="mt-6 text-right">
                <button onClick={handleSaveConfigs} className="bg-teal-500 text-white font-bold py-3 px-6 rounded-lg shadow-sm hover:bg-teal-600 transition-all" disabled={isSaving}>
                    {isSaving ? 'Guardando...' : 'Guardar Toda la Configuración'}
                </button>
            </div>
        </div>
    );
};
// PEGA ESTE NUEVO COMPONENTE COMPLETO EN TU CÓDIGO
// --- NUEVO COMPONENTE PARA REVISIÓN DE CLASIFICACIONES (ADMIN) ---
const ClassificationReviewComponent = ({ db, auth }) => {
    const [pendingProducts, setPendingProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [editingProduct, setEditingProduct] = useState(null);

    useEffect(() => {
        const q = query(collectionGroup(db, 'classified_products'), where('status', '==', 'pendiente'));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const products = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id, path: doc.ref.path }));
            setPendingProducts(products);
            setLoading(false);
        });
        return () => unsubscribe();
    }, [db]);

    const handleSaveReview = async () => {
        if (!editingProduct || !editingProduct.partida || editingProduct.partida.trim() === '') {
            return alert("La Partida Arancelaria no puede estar vacía.");
        }
        const adminUser = auth.currentUser;
        if (!adminUser) return alert("Error de autenticación.");

        try {
            const partidaLimpia = editingProduct.partida.replace(/\D/g, '');
            const palabrasClaveArray = editingProduct.palabras_clave_str ? editingProduct.palabras_clave_str.split(',').map(s => s.trim().toLowerCase()).filter(s => s) : [];
            
            const masterDBRef = doc(db, 'artifacts', 'logicstrack-app', 'public', 'data', 'arancel_maestro', partidaLimpia);
            await setDoc(masterDBRef, {
                partida: partidaLimpia,
                descripcion: editingProduct.descripcion_comercial || 'Descripción no especificada',
                dai: parseFloat(editingProduct.dai) || 0,
                permisos: editingProduct.permisos,
                palabras_clave: arrayUnion(...palabrasClaveArray)
            }, { merge: true });

            const originalProductRef = doc(db, editingProduct.path); 
            await updateDoc(originalProductRef, {
                status: 'aprobado',
                partida: partidaLimpia,
                dai: parseFloat(editingProduct.dai) || 0,
                permisos: editingProduct.permisos,
                reviewedBy: { uid: adminUser.uid, email: adminUser.email },
                reviewedAt: serverTimestamp()
            });

            alert(`¡Éxito! Producto aprobado y base de datos actualizada.`);
            setEditingProduct(null);
        } catch (error) {
            console.error("Error al guardar la revisión:", error);
            alert("Error al procesar la revisión.");
        }
    };

    const inputStyle = "w-full p-2 border border-gray-300 rounded-lg mt-1 bg-gray-50 focus:ring-2 focus:ring-teal-500";

    return (
        <div className="space-y-6">
            <div>
                <h2 className="text-3xl font-bold text-gray-800">Revisión de Clasificaciones</h2>
                <p className="text-gray-500 mt-1">Aprueba o corrige las clasificaciones de productos guardadas por los usuarios.</p>
            </div>

            <div className="bg-white border border-gray-200 p-5 rounded-2xl shadow-sm">
                {loading ? <p>Cargando...</p> : pendingProducts.length === 0 ? (
                    <p className="text-center text-gray-500 py-8">¡Excelente! No hay productos pendientes de revisión.</p>
                ) : (
                    <div className="divide-y divide-gray-200">
                        {pendingProducts.map(product => (
                            <div key={product.id} className="flex flex-col sm:flex-row justify-between items-start sm:items-center py-4">
                                <div className="flex-grow">
                                    <p className="font-semibold text-gray-800">{product.descripcion_comercial}</p>
                                    <p className="text-sm text-gray-500">Partida sugerida: <span className="font-mono">{product.partida}</span></p>
                                    <p className="text-xs text-gray-400">Enviado por: {product.createdBy?.email || 'N/A'}</p>
                                </div>
                                <div className="mt-2 sm:mt-0">
                                    <button onClick={() => setEditingProduct(product)} className="bg-blue-500 text-white text-sm font-bold py-1.5 px-4 rounded-full hover:bg-blue-600 transition-colors">Revisar</button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* Modal para editar y aprobar */}
            {editingProduct && (
                <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-50 p-4">
                    <div className="bg-white p-6 rounded-2xl shadow-xl space-y-4 w-full max-w-2xl text-gray-800 animate-fade-in-up">
                        <h3 className="text-xl font-bold border-b pb-3">Revisar y Aprobar Clasificación</h3>
                        <p><span className="font-semibold">Producto:</span> {editingProduct.descripcion_comercial}</p>
                        <p><span className="font-semibold">Sugerencia del cliente:</span> <span className="font-mono">{editingProduct.partida}</span></p>
                        
                        <div className="space-y-4 pt-4">
                             <div>
                                <label className="block text-sm font-medium">Partida Arancelaria (Corregir si es necesario)</label>
                                <input type="text" value={editingProduct.partida} onChange={(e) => setEditingProduct({...editingProduct, partida: e.target.value})} className={inputStyle} />
                            </div>
                            <div>
                                <label className="block text-sm font-medium">DAI (%)</label>
                                <input type="number" placeholder="Ej: 15" value={editingProduct.dai || ''} onChange={(e) => setEditingProduct({...editingProduct, dai: e.target.value})} className={inputStyle} />
                            </div>
                            <div>
                                <label className="block text-sm font-medium">Permisos / Requisitos</label>
                                <textarea value={editingProduct.permisos || ''} onChange={(e) => setEditingProduct({...editingProduct, permisos: e.target.value})} className={inputStyle} rows="2"></textarea>
                            </div>
                            <div>
                                <label className="block text-sm font-medium">Palabras Clave (para búsquedas futuras, separadas por coma)</label>
                                <input type="text" placeholder="Ej: zapato, calzado, cuero, bota" onChange={(e) => setEditingProduct({...editingProduct, palabras_clave_str: e.target.value})} className={inputStyle} />
                            </div>
                        </div>

                        <div className="flex justify-end space-x-2 pt-4 border-t">
                            <button onClick={() => setEditingProduct(null)} className="bg-gray-200 text-gray-800 font-bold py-2 px-5 rounded-lg hover:bg-gray-300">Cancelar</button>
                            <button onClick={handleSaveReview} className="bg-green-600 text-white font-bold py-2 px-5 rounded-lg hover:bg-green-700">Aprobar y Guardar</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
// PEGA ESTE CÓDIGO NUEVO AQUÍ
// --- COMPONENTE PARA GESTIÓN DE BASE DE DATOS ARANCELARIA (SAC) ---
const AdminDatabaseComponent = ({ db, allUsers }) => {
    const [selectedClient, setSelectedClient] = useState('');
    const [clientProducts, setClientProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [uploadMessage, setUploadMessage] = useState('');
    const [editingProduct, setEditingProduct] = useState(null); // Estado para el modal de edición

    useEffect(() => {
        if (!selectedClient) {
            setClientProducts([]);
            return;
        }
        setIsLoading(true);
        const productsRef = collection(db, 'artifacts', 'logicstrack-app', 'users', selectedClient, 'classified_products');
        const q = query(productsRef, orderBy('createdAt', 'desc'));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const products = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setClientProducts(products);
            setIsLoading(false);
        });

        return () => unsubscribe();
    }, [db, selectedClient]);

    const handleFileUpload = (e) => {
        // ... (lógica de subida de archivo sin cambios) ...
        const file = e.target.files[0];
        if (!file) return;
        setUploadMessage('Procesando archivo... Creando índice de búsqueda...');
        const reader = new FileReader();
        reader.onload = async (event) => {
            try {
                const data = event.target.result;
                const workbook = window.XLSX.read(data, { type: 'binary' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = window.XLSX.utils.sheet_to_json(worksheet);
                if (json.length === 0) throw new Error("El archivo está vacío.");
                if (!json[0].codigo_sac || !json[0].descripcion || json[0].dai === undefined) {
                    throw new Error("El archivo Excel debe tener las columnas: 'codigo_sac', 'descripcion' y 'dai'.");
                }
                const batch = writeBatch(db);
                const stopWords = new Set(['de', 'la', 'los', 'las', 'y', 'o', 'con', 'sin', 'sus', 'partes']);
                json.forEach((row) => {
                    const partida = String(row.codigo_sac).replace(/\D/g, '');
                    if (!partida) return;
                    const descripcion = String(row.descripcion).trim();
                    const keywords = descripcion.toLowerCase().replace(/[^a-záéíóúñ\s]/g, '').split(/\s+/).filter(word => word.length > 2 && !stopWords.has(word));
                    const docRef = doc(db, 'artifacts', 'logicstrack-app', 'public', 'data', 'arancel_maestro', partida);
                    batch.set(docRef, {
                        partida: partida,
                        descripcion: descripcion,
                        dai: Number(row.dai) || 0,
                        palabras_clave: [...new Set(keywords)]
                    }, { merge: true });
                });
                await batch.commit();
                setUploadMessage(`¡Éxito! Se actualizó la base de datos maestra con ${json.length} registros.`);
            } catch (error) {
                setUploadMessage(`Error: ${error.message}`);
            }
        };
        reader.readAsBinaryString(file);
    };
    
    // --- NUEVAS FUNCIONES PARA EDITAR ---
    const handleEditClick = (product) => {
        setEditingProduct({ ...product }); // Abre el modal con los datos del producto
    };

    const handleSaveChanges = async () => {
        if (!editingProduct) return;
        
        const productRef = doc(db, 'artifacts', 'logicstrack-app', 'users', selectedClient, 'classified_products', editingProduct.id);
        
        try {
            // Preparamos los datos para evitar guardar campos no deseados
            const { id, path, createdBy, createdAt, ...dataToUpdate } = editingProduct;
            await updateDoc(productRef, dataToUpdate);
            alert("Producto actualizado con éxito.");
            setEditingProduct(null); // Cierra el modal
        } catch (error) {
            console.error("Error al actualizar el producto:", error);
            alert("Hubo un error al guardar los cambios.");
        }
    };

    const handleModalInputChange = (e) => {
        const { name, value } = e.target;
        setEditingProduct(prev => ({ ...prev, [name]: value }));
    };

    const inputStyle = "w-full p-2 border border-gray-300 rounded-lg mt-1 bg-gray-50 focus:ring-2 focus:ring-teal-500";
    
    return (
        <div className="space-y-6">
            <div>
                <h2 className="text-3xl font-bold text-gray-800">Bases de Datos</h2>
                <p className="text-gray-500 mt-1">Gestiona la información clasificada de tus clientes y actualiza el arancel maestro.</p>
            </div>

            {/* Tarjeta de Base de Datos por Cliente */}
            <div className="bg-white border border-gray-200 p-6 rounded-2xl shadow-sm">
                <h3 className="text-xl font-bold text-gray-800">Base de Datos por Cliente</h3>
                <p className="text-sm text-gray-600 mt-1 mb-4">Selecciona un cliente para ver y gestionar sus productos clasificados.</p>
                <Select
                    options={allUsers.map(user => ({ value: user.uid, label: user.name || user.email }))}
                    onChange={option => setSelectedClient(option.value)}
                    placeholder="Busca o selecciona un cliente..."
                />
                
                {isLoading && <p className="mt-4 text-center text-gray-500">Cargando productos...</p>}

                {!isLoading && selectedClient && (
                    <div className="mt-6 overflow-x-auto">
                        {clientProducts.length > 0 ? (
                            <table className="min-w-full text-sm">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="py-2 px-3 text-left font-semibold text-gray-600">Descripción</th>
                                        <th className="py-2 px-3 text-left font-semibold text-gray-600">Partida</th>
                                        <th className="py-2 px-3 text-left font-semibold text-gray-600">Estado</th>
                                        <th className="py-2 px-3 text-left font-semibold text-gray-600">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                    {clientProducts.map(prod => (
                                        <tr key={prod.id}>
                                            <td className="py-2 px-3">{prod.descripcion_comercial}</td>
                                            <td className="py-2 px-3 font-mono">{prod.partida}</td>
                                            <td className="py-2 px-3">
                                                <span className={`px-2 py-1 text-xs font-medium rounded-full ${prod.status === 'aprobado' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`}>
                                                    {prod.status}
                                                </span>
                                            </td>
                                            <td className="py-2 px-3">
                                                <button onClick={() => handleEditClick(prod)} className="text-blue-600 hover:underline text-xs font-semibold">Editar</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                             <p className="mt-4 text-center text-gray-500 py-6">Este cliente no tiene productos guardados.</p>
                        )}
                    </div>
                 )}
            </div>

            {/* Tarjeta para Actualizar SAC */}
            <div className="bg-white border border-gray-200 p-6 rounded-2xl shadow-sm">
                <h3 className="text-xl font-bold text-gray-800">Actualizar Arancel Maestro (SAC)</h3>
                <p className="text-sm text-gray-600 mt-1 mb-4">Sube el archivo Excel maestro con las columnas: <strong>codigo_sac, descripcion, dai</strong>.</p>
                <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-teal-50 file:text-teal-700 hover:file:bg-teal-100" />
                {uploadMessage && <p className="mt-2 font-semibold text-blue-600">{uploadMessage}</p>}
            </div>

            {/* --- MODAL DE EDICIÓN --- */}
            {editingProduct && (
                <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-50 p-4">
                    <div className="bg-white p-6 rounded-2xl shadow-xl space-y-4 w-full max-w-2xl text-gray-800 animate-fade-in-up">
                        <h3 className="text-xl font-bold border-b pb-3">Editar Producto Clasificado</h3>
                        <div className="space-y-4 pt-4">
                            <div>
                                <label className="block text-sm font-medium">Descripción Comercial</label>
                                <input name="descripcion_comercial" value={editingProduct.descripcion_comercial} onChange={handleModalInputChange} className={inputStyle} />
                            </div>
                             <div>
                                <label className="block text-sm font-medium">Partida Arancelaria</label>
                                <input name="partida" value={editingProduct.partida} onChange={handleModalInputChange} className={inputStyle} />
                            </div>
                            <div>
                                <label className="block text-sm font-medium">Estado</label>
                                <select name="status" value={editingProduct.status} onChange={handleModalInputChange} className={inputStyle}>
                                    <option value="pendiente">Pendiente</option>
                                    <option value="aprobado">Aprobado</option>
                                </select>
                            </div>
                             <div>
                                <label className="block text-sm font-medium">Permisos</label>
                                <textarea name="permisos" value={editingProduct.permisos || ''} onChange={handleModalInputChange} className={inputStyle} rows="2"></textarea>
                            </div>
                        </div>
                        <div className="flex justify-end space-x-2 pt-4 border-t">
                            <button onClick={() => setEditingProduct(null)} className="bg-gray-200 text-gray-800 font-bold py-2 px-5 rounded-lg hover:bg-gray-300">Cancelar</button>
                            <button onClick={handleSaveChanges} className="bg-teal-500 text-white font-bold py-2 px-5 rounded-lg hover:bg-teal-600">Guardar Cambios</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
    // --- Componente para Crear Envíos Manualmente (Admin) ---
const CreateShipmentComponent = ({ db, onClose, allUsers }) => {
    const countryOptions = useMemo(() => countryList().getData(), []);
    const [shipmentDirection, setShipmentDirection] = useState('import'); // 'import' o 'export'
    const [newShipment, setNewShipment] = useState({
        shipment_id: '',
        client_id: '',
        origin: shipmentDirection === 'export' ? 'El Salvador' : '',
        destination: shipmentDirection === 'import' ? 'El Salvador' : '',
        transport_type: 'Maritimo',
        modality: 'FCL',
        status: 'Pendiente de Aprobación',
        
        // --- CAMPOS DE FECHA AÑADIDOS ---
        eta_prometida: '',       // Fecha de entrega prometida
        pickup_at: '',           // Fecha de recolección
        departure_port: '',      // Fecha de zarpe/despegue
        arrival_port: '',        // Fecha de arribo
        customs_clear_start: '', // Inicio de aduana
        customs_clear_end: '',   // Liberación de aduana
        delivered_at: '',        // Entrega final
    });
    const [isSaving, setIsSaving] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        setNewShipment(prev => ({
            ...prev,
            origin: shipmentDirection === 'export' ? 'El Salvador' : (prev.origin || ''),
            destination: shipmentDirection === 'import' ? 'El Salvador' : (prev.destination || ''),
        }));
    }, [shipmentDirection]);
    
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewShipment(prev => ({ ...prev, [name]: value }));
    };

    const handleSelectChange = (fieldName, selectedOption) => {
        setNewShipment(prev => ({ ...prev, [fieldName]: selectedOption.label }));
    };
    
    const handleClientSelectChange = (selectedOption) => {
        setNewShipment(prev => ({...prev, client_id: selectedOption.value}));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!newShipment.shipment_id || !newShipment.client_id) {
            setError('El ID de Envío y el Cliente son obligatorios.');
            return;
        }
        setIsSaving(true);
        setError('');

        try {
            const appId = 'logicstrack-app';
            const shipmentsCollectionRef = collection(db, 'artifacts', appId, 'public', 'data', 'shipments');
            
            // Convertir fechas de string a Timestamp de Firebase antes de guardar
            const shipmentDataToSave = {
                ...newShipment,
                eta_prometida: newShipment.eta_prometida ? Timestamp.fromDate(new Date(newShipment.eta_prometida)) : null,
                pickup_at: newShipment.pickup_at ? Timestamp.fromDate(new Date(newShipment.pickup_at)) : null,
                departure_port: newShipment.departure_port ? Timestamp.fromDate(new Date(newShipment.departure_port)) : null,
                arrival_port: newShipment.arrival_port ? Timestamp.fromDate(new Date(newShipment.arrival_port)) : null,
                customs_clear_start: newShipment.customs_clear_start ? Timestamp.fromDate(new Date(newShipment.customs_clear_start)) : null,
                customs_clear_end: newShipment.customs_clear_end ? Timestamp.fromDate(new Date(newShipment.customs_clear_end)) : null,
                delivered_at: newShipment.delivered_at ? Timestamp.fromDate(new Date(newShipment.delivered_at)) : null,
                creation_date: serverTimestamp(),
                last_updated: serverTimestamp(),
            };

            await addDoc(shipmentsCollectionRef, shipmentDataToSave);

            const updatesCollectionRef = collection(db, 'artifacts', 'logicstrack-app', 'public', 'data', 'shipment_updates');
            await addDoc(updatesCollectionRef, {
                shipment_id_text: newShipment.shipment_id,
                new_status_text: newShipment.status,
                client_id: newShipment.client_id,
                timestamp: serverTimestamp()
            });

            setIsSaving(false);
            onClose(); 
        } catch (err) {
            console.error("Error creando el envío:", err);
            setError('No se pudo crear el envío. Inténtalo de nuevo.');
            setIsSaving(false);
        }
    };

    return (
        <div className="bg-white p-6 rounded-xl shadow-lg border">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Crear Nuevo Envío Manualmente</h2>
            
            <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Operación</label>
                <div className="flex rounded-md shadow-sm">
                    <button type="button" onClick={() => setShipmentDirection('import')} className={`px-4 py-2 rounded-l-lg border ${shipmentDirection === 'import' ? 'bg-teal-500 text-white border-teal-500' : 'bg-white'}`}>Importación</button>
                    <button type="button" onClick={() => setShipmentDirection('export')} className={`px-4 py-2 rounded-r-lg border ${shipmentDirection === 'export' ? 'bg-teal-500 text-white border-teal-500' : 'bg-white'}`}>Exportación</button>
                </div>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700">ID de Envío (Ej: ENV-003)</label>
                    <input type="text" name="shipment_id" value={newShipment.shipment_id} onChange={handleInputChange} className="w-full p-2 border rounded-lg mt-1" required />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Asignar a Cliente</label>
                    <Select options={allUsers.map(user => ({ value: user.uid, label: user.name || user.email }))} onChange={handleClientSelectChange} placeholder="Busca o selecciona un cliente..." className="mt-1" required/>
                </div>
                
                <fieldset className="border p-4 rounded-lg mt-4">
                    <legend className="text-lg font-semibold px-2 text-gray-700">Fechas Clave del Envío</legend>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-2">
                        <div>
                            <label className="block text-sm font-medium text-gray-700">ETA Prometida</label>
                            <input type="date" name="eta_prometida" value={newShipment.eta_prometida} onChange={handleInputChange} className="w-full p-2 border rounded-lg mt-1" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Fecha de Recolección</label>
                            <input type="date" name="pickup_at" value={newShipment.pickup_at} onChange={handleInputChange} className="w-full p-2 border rounded-lg mt-1" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Salida de Puerto/Aeropuerto</label>
                            <input type="date" name="departure_port" value={newShipment.departure_port} onChange={handleInputChange} className="w-full p-2 border rounded-lg mt-1" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Arribo a Puerto/Aeropuerto</label>
                            <input type="date" name="arrival_port" value={newShipment.arrival_port} onChange={handleInputChange} className="w-full p-2 border rounded-lg mt-1" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Inicio de Aduana</label>
                            <input type="date" name="customs_clear_start" value={newShipment.customs_clear_start} onChange={handleInputChange} className="w-full p-2 border rounded-lg mt-1" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Liberación de Aduana</label>
                            <input type="date" name="customs_clear_end" value={newShipment.customs_clear_end} onChange={handleInputChange} className="w-full p-2 border rounded-lg mt-1" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Entrega Final</label>
                            <input type="date" name="delivered_at" value={newShipment.delivered_at} onChange={handleInputChange} className="w-full p-2 border rounded-lg mt-1" />
                        </div>
                    </div>
                </fieldset>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Origen</label>
                        {shipmentDirection === 'import' ? (
                            <Select options={countryOptions} onChange={option => handleSelectChange('origin', option)} placeholder="Busca un país..." className="mt-1" />
                        ) : (
                            <input type="text" value="El Salvador" className="w-full p-2 border rounded-lg mt-1 bg-gray-100" readOnly />
                        )}
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Destino</label>
                        {shipmentDirection === 'export' ? (
                            <Select options={countryOptions} onChange={option => handleSelectChange('destination', option)} placeholder="Busca un país..." className="mt-1" />
                        ) : (
                            <input type="text" value="El Salvador" className="w-full p-2 border rounded-lg mt-1 bg-gray-100" readOnly />
                        )}
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Tipo de Transporte</label>
                        <select name="transport_type" value={newShipment.transport_type} onChange={handleInputChange} className="w-full p-2 border rounded-lg mt-1">
                            <option value="Maritimo">Marítimo</option>
                            <option value="Aereo">Aéreo</option>
                            <option value="Terrestre">Terrestre</option>
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Modalidad</label>
                        <select name="modality" value={newShipment.modality} onChange={handleInputChange} className="w-full p-2 border rounded-lg mt-1">
                            <option value="FCL">FCL</option>
                            <option value="LCL">LCL</option>
                            <option value="FTL">FTL</option>
                            <option value="LTL">LTL</option>
                        </select>
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700">Estado Inicial</label>
                    <select name="status" value={newShipment.status} onChange={handleInputChange} className="w-full p-2 border rounded-lg mt-1">
                        <option>Pendiente de Aprobación</option>
                        <option>En Tránsito</option>
                        <option>En Aduana</option>
                        <option>Liberado</option>
                        <option>Entregado</option>
                        <option>Retrasado</option>
                    </select>
                </div>

                {error && <p className="text-red-500 text-sm text-center">{error}</p>}
                <div className="flex justify-end space-x-4 pt-4">
                    <button type="button" onClick={onClose} className="bg-gray-200 text-gray-800 font-bold py-2 px-4 rounded-lg hover:bg-gray-300">Cancelar</button>
                    <button type="submit" className="bg-teal-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-teal-700" disabled={isSaving}>
                        {isSaving ? 'Guardando...' : 'Guardar Envío'}
                    </button>
                </div>
            </form>
        </div>
    );
};

// ===================================================================================
// NUEVO COMPONENTE: REPORTES DE BUSINESS INTELLIGENCE
// ===================================================================================
// --- PEGA ESTA FUNCIÓN AYUDANTE AFUERA (ANTES) DE TU COMPONENTE ---
// Esta pequeña función nos ayudará a calcular la diferencia en días entre dos fechas.
const daysBetween = (timeStamp1, timeStamp2) => {
    if (!timeStamp1 || !timeStamp2) return null;
    const date1 = timeStamp1.toDate();
    const date2 = timeStamp2.toDate();
    const differenceInTime = date2.getTime() - date1.getTime();
    return differenceInTime / (1000 * 3600 * 24);
};

// PEGA ESTA NUEVA FUNCIÓN DEBAJO DE 'daysBetween'
const getSlaForShipment = (shipment, slaConfig, metric) => {
    if (!shipment || !slaConfig) return 0; // Si no hay datos, devuelve 0

    const type = shipment.transport_type?.toLowerCase();

    if (type === 'maritimo' || type === 'aereo') {
        return slaConfig[type]?.[metric] || 0;
    }

    if (type === 'terrestre') {
        const destination = shipment.destination?.toLowerCase().replace(/\s/g, '');
        // Busca un SLA específico para el país de destino
        if (slaConfig.terrestre && slaConfig.terrestre[destination]) {
            return slaConfig.terrestre[destination][metric] || 0;
        }
        // Si no hay uno específico, usa un valor por defecto si existe
        return slaConfig.terrestre?.default?.[metric] || 0;
    }

    return 0; // Si no es ninguno de los anteriores
};

// ===================================================================================
// REEMPLAZA TU COMPONENTE DE REPORTES CON ESTA VERSIÓN FINAL
// ===================================================================================
const ReportsComponent = ({ shipments, userRole, allUsers, userId, slaConfig }) => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [selectedClient, setSelectedClient] = useState(userRole === 'user' ? userId : 'todos');
    const [reportData, setReportData] = useState(null);

    const generateReport = () => {
        let filteredShipments = shipments;
        if (userRole !== 'user' && selectedClient !== 'todos') {
            filteredShipments = filteredShipments.filter(s => s.client_id === selectedClient);
        }
        if (startDate) {
            const start = new Date(startDate); start.setUTCHours(0, 0, 0, 0);
            filteredShipments = filteredShipments.filter(s => s.creation_date && s.creation_date.toDate() >= start);
        }
        if (endDate) {
            const end = new Date(endDate); end.setUTCHours(23, 59, 59, 999);
            filteredShipments = filteredShipments.filter(s => s.creation_date && s.creation_date.toDate() <= end);
        }

        let totalShipments = filteredShipments.length;
        let onTimeCount = 0; let deliveredCount = 0; let leadTimes = []; let customsTimes = []; let etaErrors = [];
        filteredShipments.forEach(s => {
            if (s.delivered_at && s.eta_prometida) {
                deliveredCount++;
                if (s.delivered_at.toDate() <= s.eta_prometida.toDate()) { onTimeCount++; }
            }
            const leadTime = daysBetween(s.pickup_at, s.delivered_at); if (leadTime !== null) leadTimes.push(leadTime);
            const customsTime = daysBetween(s.customs_clear_start, s.customs_clear_end); if (customsTime !== null) customsTimes.push(customsTime);
            const etaError = daysBetween(s.eta_prometida, s.delivered_at); if (etaError !== null) etaErrors.push(Math.abs(etaError));
        });

        const otdPercentage = deliveredCount > 0 ? (onTimeCount / deliveredCount) * 100 : 0;
        const avgLeadTime = leadTimes.length > 0 ? leadTimes.reduce((a, b) => a + b, 0) / leadTimes.length : 0;
        const avgCustomsTime = customsTimes.length > 0 ? customsTimes.reduce((a, b) => a + b, 0) / customsTimes.length : 0;
        const etaMae = etaErrors.length > 0 ? etaErrors.reduce((a, b) => a + b, 0) / etaErrors.length : 0;
        
        setReportData({
            total: totalShipments, otd: otdPercentage, avgLeadTime: avgLeadTime, avgCustomsTime: avgCustomsTime, etaMae: etaMae
        });
    };

    return (
        <div className="space-y-6">
            <div>
                <h2 className="text-3xl font-bold text-gray-800">Centro de Reportes y BI</h2>
                <p className="text-gray-500 mt-1">Filtra y genera reportes para analizar el desempeño de tu operación.</p>
            </div>

            <div className="bg-white border border-gray-200 p-5 rounded-2xl shadow-sm">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
                    {userRole !== 'user' && (
                        <div>
                            <label className="block text-sm font-medium">Cliente</label>
                            <select value={selectedClient} onChange={e => setSelectedClient(e.target.value)} className="w-full p-2 border-gray-300 bg-gray-50 rounded-lg mt-1">
                                <option value="todos">Todos los Clientes</option>
                                {allUsers.map(user => <option key={user.uid} value={user.uid}>{user.name || user.email}</option>)}
                            </select>
                        </div>
                    )}
                    <div>
                        <label className="block text-sm font-medium">Fecha de Inicio</label>
                        <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} className="w-full p-2 border-gray-300 bg-gray-50 rounded-lg mt-1" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium">Fecha de Fin</label>
                        <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} className="w-full p-2 border-gray-300 bg-gray-50 rounded-lg mt-1" />
                    </div>
                    <button onClick={generateReport} className="bg-teal-500 text-white font-bold py-2 px-4 rounded-lg h-10 w-full hover:bg-teal-600">Generar Reporte</button>
                </div>
            </div>

            {reportData && (
                <div className="space-y-6 animate-fade-in">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                         <div className="bg-white border p-5 rounded-2xl shadow-sm"><p className="text-gray-500 text-sm">Total de Envíos</p><p className="text-3xl font-bold text-gray-800">{reportData.total}</p></div>
                         <div className="bg-white border p-5 rounded-2xl shadow-sm"><p className="text-gray-500 text-sm">On-Time Delivery (OTD)</p><p className="text-3xl font-bold text-green-600">{reportData.otd.toFixed(1)}%</p></div>
                         <div className="bg-white border p-5 rounded-2xl shadow-sm"><p className="text-gray-500 text-sm">Lead Time Promedio</p><p className="text-3xl font-bold text-gray-800">{reportData.avgLeadTime.toFixed(1)} <span className="text-lg font-medium text-gray-500">días</span></p></div>
                         <div className="bg-white border p-5 rounded-2xl shadow-sm"><p className="text-gray-500 text-sm">Tiempo Promedio en Aduana</p><p className="text-3xl font-bold text-gray-800">{reportData.avgCustomsTime.toFixed(1)} <span className="text-lg font-medium text-gray-500">días</span></p></div>
                    </div>
                    <PerformanceChart title="Rendimiento General del Periodo" shipments={shipments} slaConfig={slaConfig} timeKey={{ start: 'pickup_at', end: 'delivered_at', metric: 'leadTime' }} labelKey="días"/>
                </div>
            )}
        </div>
    );
};

// Componente de Clasificación con IA
// Reemplaza tu ClassificationContent completo con este
const ClassificationContent = ({db, userId, classifiedDB, handleClassifyProduct, newClassifiedProduct, setNewClassifiedProduct, userRole, functions}) => {
    const [extractedData, setExtractedData] = useState([]);
    const [classifiedData, setClassifiedData] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const [ocrError, setOcrError] = useState('');
    const [processingStatus, setProcessingStatus] = useState('');
    const [selectedFiles, setSelectedFiles] = useState(null);

    const handleFileSelection = (event) => {
        if (event.target.files && event.target.files.length > 0) {
            setSelectedFiles(event.target.files);
            setExtractedData([]);
            setOcrError('');
        } else {
            setSelectedFiles(null);
        }
    };

    const handleProcessFiles = async () => {
    const files = selectedFiles;
    if (!files || files.length === 0) return;

    setIsProcessing(true);
    setExtractedData([]);
    setOcrError("");
    setProcessingStatus(`Iniciando procesamiento de ${files.length} archivo(s)...`);
    try {
        // CORRECCIÓN: Ya no se define 'const functions = ...' aquí.
        // Ahora se usa la variable 'functions' que el componente recibe por props.
        const callGeminiVision = httpsCallable(functions, 'callGeminiVision');

        let allProducts = [];
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            setProcessingStatus(`Procesando archivo ${i + 1}/${files.length}: ${file.name}`);

            if (file.type.startsWith("image/") || file.type === "application/pdf") {
                const base64String = await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result.split(",")[1]);
                    reader.onerror = reject;
                    reader.readAsDataURL(file);
                });
                const result = await callGeminiVision({
                    base64ImageData: base64String,
                    mimeType: file.type,
                });
                console.log("Datos recibidos de la Cloud Function:", result.data);

                const productsData = result.data;
                if (productsData && productsData.productos && productsData.productos.length > 0) {
                    allProducts.push(
                        ...productsData.productos.map((p) => ({ ...p, factura: productsData.factura || file.name }))
                    );
                } else {
                    setOcrError(`La IA procesó el archivo ${file.name} pero no encontró productos.`);
                }
            } else {
                 setOcrError(`El archivo ${file.name} no es un formato válido.`);
            }
        }
        setExtractedData(allProducts);
    } catch (error) {
        console.error("Error definitivo al llamar la función:", error);
        setOcrError("FALLÓ la llamada a la función. Error: " + error.message);
    } finally {
        setIsProcessing(false);
        setProcessingStatus("Procesamiento completado.");
    }
};

    const handleDownloadExcel = () => { /* Tu lógica aquí */ };
    const handleClassifiedUpload = (event) => { /* Tu lógica aquí */ };
    const handleExportPDF = () => { /* Tu lógica aquí */ };
        
    if (userRole === 'admin' || userRole === 'superadmin') {
        return (
            <div className="space-y-6">
                 <div>
                    <h2 className="text-3xl font-bold text-gray-800">Herramientas de Clasificación (Admin)</h2>
                    <p className="text-gray-500 mt-1">Utiliza la IA para acelerar el proceso de clasificación de facturas.</p>
                </div>

                <div className="bg-white border border-gray-200 p-6 rounded-2xl shadow-sm space-y-4">
                    <h3 className="text-xl font-bold text-gray-800">Paso 1: Cargar Factura(s) con IA (OCR)</h3>
                    <p className="text-sm text-gray-600">Sube imágenes (JPG, PNG) o PDF. La IA leerá los productos y creará una plantilla de Excel para ti.</p>
                    
                    <input type="file" accept="image/*,.pdf" onChange={handleFileSelection} multiple className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-teal-50 file:text-teal-700 hover:file:bg-teal-100"/>
                    
                    <p className="text-sm text-gray-600 mt-2">{selectedFiles ? selectedFiles.length : 0} archivo(s) seleccionado(s) para procesar.</p>

                    <button 
                        onClick={handleProcessFiles} 
                        disabled={!selectedFiles || isProcessing}
                        className="bg-blue-600 text-white font-bold py-2 px-5 rounded-lg shadow-sm hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition duration-300 flex items-center justify-center min-w-[200px] h-[42px]"
                    >
                        {isProcessing ? (
                            <>
                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                                Procesando...
                            </>
                        ) : ( 'Procesar Factura(s) con IA' )}
                    </button>

                    {isProcessing && <p className="mt-2 text-teal-600 font-semibold">{processingStatus}</p>}
                    {ocrError && <p className="mt-2 text-red-600 font-semibold">{ocrError}</p>}
                    
                    {extractedData.length > 0 && (
                        <div className="mt-4 animate-fade-in">
                            <h4 className="font-bold text-gray-700">Datos Extraídos:</h4>
                            {/* Aquí puedes agregar la tabla de resultados */}
                            <button onClick={handleDownloadExcel} className="mt-4 bg-green-600 text-white font-bold py-2 px-5 rounded-lg shadow-sm hover:bg-green-700 transition duration-300">
                                Descargar Excel para Clasificar
                            </button>
                        </div>
                    )}
                </div>

                <div className="bg-white border border-gray-200 p-6 rounded-2xl shadow-sm space-y-4">
                    <h3 className="text-xl font-bold text-gray-800">Paso 2: Cargar Excel Clasificado</h3>
                     <p className="text-sm text-gray-600">Sube el archivo Excel que completaste en el paso 1 para generar el resumen final en PDF.</p>
                    <input type="file" accept=".xlsx, .xls" onChange={handleClassifiedUpload} className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" />
                    {classifiedData && (
                        <div className="mt-4 animate-fade-in">
                            <button onClick={handleExportPDF} className="mt-4 bg-red-500 text-white font-bold py-2 px-5 rounded-lg shadow-sm hover:bg-red-600">Exportar Resumen PDF</button>
                        </div>
                    )}
                </div>
            </div>
        );
    }
    
    // Vista para Usuario Normal
    return ( <div><h2>Asistente de Clasificación</h2></div> );
};


// Reemplaza tu componente NavBar completo con este
// --- COMPONENTE DE BARRA LATERAL (SIDEBAR) CORREGIDO Y CON ANIMACIONES ---
const Sidebar = ({ userRole, activeTab, setActiveTab, onLogout, setVerifyAction, userEmail }) => {
    const [isExpanded, setIsExpanded] = useState(true);

    const tabs = {
        user: ['home', 'shipments', 'clasificacion', 'reportes','privacidad'],
        admin: ['home', 'shipments', 'clasificacion', 'revisiones', 'solicitudes', 'admin', 'database', 'clientes', 'reportes','privacidad'],
        superadmin: ['home', 'shipments', 'clasificacion', 'revisiones', 'solicitudes', 'admin', 'database', 'clientes', 'equipo', 'historial', 'reportes','privacidad']
    };
    
    const navTabs = tabs[userRole] || tabs.user; 

    const tabDetails = {
        home: { label: 'Inicio', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg> },
        shipments: { label: 'Envíos', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" /></svg> },
        clasificacion: { label: 'Clasificación', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg> },
        revisiones: { label: 'Revisiones', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg> },
        solicitudes: { label: 'Solicitudes', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg> },
        admin: { label: 'Admin', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg> },
        database: { label: 'Base de Datos', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4M4 7s0 0 0 0m16 0s0 0 0 0M12 11a4 4 0 110-8 4 4 0 010 8z" /></svg> },
        clientes: { label: 'Clientes', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.653-.125-1.274-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.653.125-1.274.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg> },
        equipo: { label: 'Gestionar Equipo', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2m-6.5-1a3.001 3.001 0 00-2.83 2" /></svg> },
        historial: { label: 'Historial', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg> },
        reportes: { label: 'Reportes', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" /></svg> },
        privacidad: { label: 'Privacidad', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg> }
    };

    return (
        <aside className={`bg-gray-800 text-gray-200 flex flex-col transition-all duration-300 ease-in-out ${isExpanded ? 'w-64' : 'w-20'}`}>
            {/* Logo y Botón de colapsar */}
            <div className="flex items-center justify-between p-4 border-b border-gray-700">
                {isExpanded && (
                    <div className="flex items-center space-x-2">
                        <img src="https://firebasestorage.googleapis.com/v0/b/logicstrack-app.firebasestorage.app/o/logotipo1.png?alt=media&token=245b5ced-2e7e-46fd-94bd-b3b693ceb286" alt="Logo" className="h-8 w-auto" />
                        <span className="font-bold text-lg">LogicsTrack</span>
                    </div>
                )}
                <button onClick={() => setIsExpanded(!isExpanded)} className="p-2 rounded-lg hover:bg-gray-700">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
                    </svg>
                </button>
            </div>

            {/* Links de Navegación */}
            <nav className="flex-grow pt-4">
                {navTabs.map(tab => {
                    const isActive = activeTab === tab;
                    return (
                        <button 
                            key={tab} 
                            onClick={() => {
                                // --- LÓGICA CORREGIDA ---
                                if (tab === 'equipo' || tab === 'historial') {
                                    // Solo muestra el modal, no cambia la pestaña activa
                                    setVerifyAction({ show: true, targetTab: tab });
                                } else {
                                    setActiveTab(tab);
                                }
                            }}
                            className={`w-full flex items-center space-x-4 px-4 py-3 transition-colors duration-200 ${isActive ? 'bg-teal-500 text-white font-semibold' : 'text-gray-400 hover:bg-gray-700 hover:text-white'}`}
                            title={tabDetails[tab].label}
                        >
                            {/* Añadimos la clase de animación si la pestaña está activa */}
                            <span className={isActive ? 'animate-pulse-icon' : ''}>
                                {tabDetails[tab].icon}
                            </span>
                            {isExpanded && <span>{tabDetails[tab].label}</span>}
                        </button>
                    );
                })}
            </nav>

            {/* Footer de la Sidebar */}
            <div className="p-4 border-t border-gray-700">
                {isExpanded && <p className="text-xs text-center truncate">{userEmail}</p>}
                <button onClick={onLogout} className={`w-full flex items-center justify-center space-x-4 mt-4 px-4 py-3 rounded-lg bg-red-500 text-white hover:bg-red-600`}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>
                    {isExpanded && <span>Cerrar Sesión</span>}
                </button>
            </div>
        </aside>
    );
};

const SHIPMENT_STATUSES = [
    'Pendiente de Aprobación', 'Falta de Factura Comercial', 'Clasificación Arancelaria en Proceso',
    'Pendiente Documento de Transporte (BL/AWB)', 'Pendiente de Permisos/Inscripciones', 'En Tránsito',
    'Pendiente de Arribo', 'Nave/Vuelo Arribado', 'En Aduana', 'Pendiente Pago de Impuestos',
    'Inspección Física (Selectivo Rojo)', 'Liberado', 'Retrasado', 'Pendiente de Autorización para Entrega',
    'En Ruta de Entrega Final', 'Entregado', 'Otros'
];

    
// ======================================================================
// PEGA EL CÓDIGO DEL NUEVO PerformanceChart JUSTO EN ESTA UBICACIÓN
// ======================================================================
const PerformanceChart = ({ title, shipments, slaConfig, timeKey, labelKey }) => {
    const chartData = {
        labels: shipments.map(s => s.shipment_id),
        datasets: [
            {
                label: `Tiempo Real (${labelKey})`,
                data: shipments.map(s => daysBetween(s[timeKey.start], s[timeKey.end])),
                backgroundColor: 'rgba(59, 130, 246, 0.7)', // Azul más vibrante
                borderColor: 'rgba(59, 130, 246, 1)',
                borderWidth: 1,
                borderRadius: 4,
            },
            {
                label: `Tiempo Prometido (SLA)`,
                data: shipments.map(s => getSlaForShipment(s, slaConfig, timeKey.metric)),
                backgroundColor: 'rgba(239, 68, 68, 0.7)', // Rojo más vibrante
                borderColor: 'rgba(239, 68, 68, 1)',
                borderWidth: 1,
                borderRadius: 4,
            }
        ]
    };

    // Opciones para hacer el gráfico legible en un fondo claro
    const chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    color: '#4B5563' // Color de texto oscuro para la leyenda
                }
            },
            title: {
                display: true,
                text: title,
                color: '#111827', // Color de texto principal
                font: {
                    size: 16,
                    weight: 'bold',
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#6B7280', // Color de texto gris para el eje X
                },
                grid: {
                    display: false // Ocultamos la cuadrícula vertical para un look más limpio
                }
            },
            y: {
                ticks: {
                    color: '#6B7280', // Color de texto gris para el eje Y
                },
                grid: {
                    color: '#E5E7EB' // Líneas de la cuadrícula horizontales muy sutiles
                }
            }
        }
    };

    return (
        <div className="bg-white border border-gray-200 p-4 sm:p-6 rounded-2xl shadow-sm">
            <Bar data={chartData} options={chartOptions} />
        </div>
    );
};
// Reemplaza tu MainApp completo con este
const MainApp = ({ db, auth, userId, functions, userEmail, userRole, userPermissions, onLogout, isAuthReady, allUsers, slaConfig, classifiedDB, classifiedDBAdmin }) => {
    const [activeTab, setActiveTab] = useState('home');
    const [activeShipmentGroup, setActiveShipmentGroup] = useState('Envíos Abiertos');
    const [welcomeMessage, setWelcomeMessage] = useState('');
    const [selectedShipment, setSelectedShipment] = useState(null);
    const [shipments, setShipments] = useState([]);
    const [quoteRequests, setQuoteRequests] = useState([]);
    const [newClassifiedProduct, setNewClassifiedProduct] = useState({ descripcion: '', partida: '', permisos: '' });
    const [isCreatingShipment, setIsCreatingShipment] = useState(false);
    const [incidents, setIncidents] = useState([]);
    const [shipmentFiles, setShipmentFiles] = useState([]);
    const [uploadingFile, setUploadingFile] = useState(false);
    const [showIncidentForm, setShowIncidentForm] = useState(false);
    const [newIncident, setNewIncident] = useState({ description: '', status: 'Abierta' });
    const [verifyAction, setVerifyAction] = useState({ show: false, targetTab: null });
    const [password, setPassword] = useState('');
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // --- CORRECCIÓN: useMemo movido al lugar correcto ---
    const groupShipments = (shipments) => {
        const groups = { 'Envíos Abiertos': [], 'Envíos en Proceso': [], 'Envíos Cerrados': [] };
        const abiertos = ['Pendiente de Aprobación', 'Falta de Factura Comercial', 'Clasificación Arancelaria en Proceso', 'Pendiente Documento de Transporte (BL/AWB)', 'Pendiente de Permisos/Inscripciones'];
        const enProceso = ['En Tránsito', 'Pendiente de Arribo', 'Nave/Vuelo Arribado', 'En Aduana', 'Pendiente Pago de Impuestos', 'Inspección Física (Selectivo Rojo)', 'Liberado', 'Retrasado', 'Pendiente de Autorización para Entrega', 'En Ruta de Entrega Final'];
        const cerrados = ['Entregado'];
        shipments.forEach(shipment => {
            if (abiertos.includes(shipment.status)) groups['Envíos Abiertos'].push(shipment);
            else if (enProceso.includes(shipment.status)) groups['Envíos en Proceso'].push(shipment);
            else if (cerrados.includes(shipment.status)) groups['Envíos Cerrados'].push(shipment);
            else groups['Envíos Abiertos'].push(shipment); // Fallback
        });
        return groups;
    };
    const groupedShipments = useMemo(() => groupShipments(shipments), [shipments]);
    const recentDeliveredShipments = useMemo(() => 
    shipments.filter(s => s.status === 'Entregado').slice(0, 5) , [shipments]);

    // ... (el resto de tus funciones como handleClassifyProduct, sendPushNotification, etc., no cambian) ...
    const handleClassifyProduct = async (e) => {
        try {
            if (e && typeof e.preventDefault === "function") e.preventDefault();
            if (!db) { alert("Base de datos no lista."); return; }
            if (!userId) { alert("Debes iniciar sesión para guardar tu producto."); return; }
            const { descripcion, partida, permisos } = newClassifiedProduct || {};
            if (!descripcion || !descripcion.trim() || !partida || !partida.trim()) {
                alert("Completa al menos la Descripción y la Partida.");
                return;
            }
            const colRef = collection(db, "artifacts", "logicstrack-app", "users", String(userId), "classified_products");
            const docRef = await addDoc(colRef, {
                descripcion_comercial: descripcion.trim(),
                partida: partida.trim(),
                permisos: (permisos || "").trim(),
                status: "pendiente",
                userId: String(userId),
                createdAt: serverTimestamp()
            });
            await updateDoc(docRef, { path: docRef.path });
            setNewClassifiedProduct({ descripcion: "", partida: "", permisos: "" });
            alert("¡Producto enviado a revisión!");
        } catch (err) {
            console.error("Error guardando clasificación:", err);
            alert("No se pudo guardar. Revisa la consola para más detalle.");
        }
    };
    const sendPushNotification = async (userId, email, title, message) => {
    console.log("Paso 2: Se llamó a sendPushNotification con:", { userId, email, title, message });
    if (!db || !userId) {
        console.error("ERROR en Paso 2: Faltan 'db' o 'userId'.");
        alert("Error: Faltan datos para crear la notificación (db o userId).");
        return;
    }
    try {
        const notificationsCollectionRef = collection(db, 'notifications');
        await addDoc(notificationsCollectionRef, {
            userId: userId,
            email: email || null,
            title: title,
            message: message,
            createdAt: serverTimestamp()
        });
        console.log("Paso 3: ¡ÉXITO! Documento de notificación creado en Firestore.");
        alert("¡Éxito! La orden de notificación ha sido enviada a la nube.");
    } catch (error) {
        console.error("ERROR en Paso 3: No se pudo crear el documento en Firestore.", error);
        alert("Error crítico al intentar crear la notificación. Revisa la consola.");
    }
};
    const logAction = async (actionType, details) => {
        if (!db) return;
        try {
            const logData = {
                timestamp: serverTimestamp(),
                action: actionType,
                performedBy: { uid: userId, email: userEmail },
                details: details || {}
            };
            const logCollectionRef = collection(db, 'artifacts', 'logicstrack-app', 'public', 'data', 'audit_log');
            await addDoc(logCollectionRef, logData);
        } catch (error) {
            console.error("Error al registrar la acción en la bitácora:", error);
        }
    };
    const handleUpdateShipmentStatus = async (shipmentId, newStatus) => {
    console.log("Paso 1: Iniciando handleUpdateShipmentStatus para el envío:", shipmentId);
    try {
        const shipmentDocRef = doc(db, 'artifacts', 'logicstrack-app', 'public', 'data', 'shipments', shipmentId);
        await updateDoc(shipmentDocRef, { status: newStatus, last_updated: serverTimestamp() });
        console.log("Paso 1a: Estado actualizado en Firestore con éxito.");

        const shipmentData = shipments.find(s => s.id === shipmentId);
        if (!shipmentData) {
            console.error("ERROR en Paso 1b: No se encontró shipmentData en el estado local.");
            return;
        }
        console.log("Paso 1b: shipmentData encontrado:", shipmentData);
        
        await logAction('STATUS_CHANGED', { shipmentId: shipmentData.shipment_id, newStatus: newStatus });
        
        const client = allUsers.find(u => u.uid === shipmentData.client_id);
        if (!client) {
            console.error("ERROR en Paso 1c: No se encontró el cliente en allUsers para el client_id:", shipmentData.client_id);
            return;
        }
        const emailToSend = client?.correo_principal || client?.email || null;
        console.log("Paso 1c: Cliente y email encontrados:", { client, emailToSend });

        await sendPushNotification(
            shipmentData.client_id, 
            emailToSend,
            `Actualización: ${shipmentData.shipment_id}`, 
            `Nuevo estado: ${newStatus}`
        );
    } catch (error) {
        console.error("ERROR CRÍTICO en handleUpdateShipmentStatus:", error);
        alert("Ocurrió un error muy grave al actualizar. Revisa la consola.");
    }
};
    const handleAddIncident = async () => {
        if (!selectedShipment || !newIncident.description) {
            return alert("La descripción de la incidencia no puede estar vacía.");
        }
        await addDoc(collection(db, 'artifacts', 'logicstrack-app', 'public', 'data', 'incidents'), {
            shipment_db_id: selectedShipment.id,
            shipment_visible_id: selectedShipment.shipment_id,
            description: newIncident.description,
            status: newIncident.status,
            timestamp: serverTimestamp()
        });
        await logAction('INCIDENT_ADDED', { shipmentId: selectedShipment.shipment_id, incident: newIncident.description });
        await sendPushNotification(
            selectedShipment.client_id, 
            `Nueva incidencia en envío: ${selectedShipment.shipment_id}`,
            `${newIncident.description}`
        );
        const client = allUsers.find(u => u.uid === selectedShipment.client_id);
        const emailToSend = client?.correo_principal || client?.email;
        if (client && emailToSend) {
            const mailCollectionRef = collection(db, 'mail');
            await addDoc(mailCollectionRef, { to: [emailToSend], message: { 
                subject: `Nueva incidencia registrada para tu envío: ${selectedShipment.shipment_id}`,
                html: `<p>Hola ${client.name || 'Cliente'},</p><p>Se ha registrado una nueva incidencia para tu envío con ID <strong>${selectedShipment.shipment_id}</strong>.</p><p><strong>Detalle de la incidencia:</strong> ${newIncident.description}</p><p>Nuestro equipo ya está trabajando para resolverla.</p>`,
            } });
        }
        setNewIncident({ description: '', status: 'Abierta' });
        setShowIncidentForm(false);
    };
    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        if (!file || !selectedShipment) return;
        setUploadingFile(true);
        try {
            const storage = getStorage();
            const storageRef = ref(storage, `shipments/${selectedShipment.id}/${file.name}`);
            const snapshot = await uploadBytes(storageRef, file);
            const downloadURL = await getDownloadURL(snapshot.ref);
            const fileData = {
                name: file.name,
                url: downloadURL,
                uploadedAt: serverTimestamp(),
                uploadedBy: { uid: userId, email: userEmail }
            };
            const documentsCollectionRef = collection(db, 'artifacts', 'logicstrack-app', 'public', 'data', 'shipments', selectedShipment.id, 'documents');
            await addDoc(documentsCollectionRef, fileData);
            alert('¡Archivo subido con éxito!');
        } catch (error) {
            console.error("Error al subir el archivo:", error);
            alert("Hubo un error al subir el archivo.");
        } finally {
            setUploadingFile(false);
        }
    };
    const handleDeleteShipment = async (shipmentId) => {
        if (window.confirm("¿Estás seguro de que quieres borrar este envío?")) {
            await deleteDoc(doc(db, 'artifacts', 'logicstrack-app', 'public', 'data', 'shipments', shipmentId));
        }
    };
    const handleReauthenticate = async (e) => {
        e.preventDefault();
        const auth = getAuth();
        const user = auth.currentUser;
        if (!user) return;
        const credential = EmailAuthProvider.credential(user.email, password);
        try {
            await reauthenticateWithCredential(user, credential);
            setActiveTab(verifyAction.targetTab);
            setVerifyAction({ show: false, targetTab: null });
            setPassword('');
        } catch (error) {
            console.error("Error de re-autenticación", error);
            alert("Contraseña incorrecta. Inténtalo de nuevo.");
        }
    };

    useEffect(() => {
        const messages = ["Cada envío es un nuevo comienzo. ¡Vamos a hacerlo increíble hoy! 😊", "La logística es el arte de lo posible. ¿Qué obra maestra crearemos hoy? ✨", "Un pequeño paso en la logística, un gran salto para tu negocio. ¡Que tengas un día productivo! 🚀"];
        if (activeTab === 'home') {
            const randomIndex = Math.floor(Math.random() * messages.length);
            setWelcomeMessage(messages[randomIndex]);
        }
    }, [activeTab]);

    useEffect(() => {
    if (!isAuthReady || !auth || !db || !userId) return;
    const appId = 'logicstrack-app';
    const shipmentsCollectionRef = collection(db, 'artifacts', appId, 'public', 'data', 'shipments');
    let shipmentsQuery = (userRole === 'admin' || userRole === 'superadmin') ? shipmentsCollectionRef : query(shipmentsCollectionRef, where("client_id", "==", userId));
    
    const unsubscribeShipments = onSnapshot(shipmentsQuery, (snapshot) => {
        const shipmentsData = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
        shipmentsData.sort((a, b) => (b.creation_date?.seconds || 0) - (a.creation_date?.seconds || 0));
        setShipments(shipmentsData);
    });

    let unsubscribeQuoteRequests;
    if (userRole === 'admin' || userRole === 'superadmin') {
        const quoteRequestsCollectionRef = collection(db, 'artifacts', appId, 'public', 'data', 'quote_requests');
        unsubscribeQuoteRequests = onSnapshot(quoteRequestsCollectionRef, (snapshot) => {
            const requestsData = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
            requestsData.sort((a, b) => (b.requestDate?.seconds || 0) - (a.requestDate?.seconds || 0));
            setQuoteRequests(requestsData);
        });
    }

    let unsubscribeIncidents = null;
    let unsubscribeShipmentDocuments = null;
    if (selectedShipment && db) {
        const incidentsQuery = query(collection(db, 'artifacts', 'logicstrack-app', 'public', 'data', 'incidents'), where("shipment_db_id", "==", selectedShipment.id), orderBy("timestamp", "desc"));
        unsubscribeIncidents = onSnapshot(incidentsQuery, (snapshot) => {
            setIncidents(snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })));
        });
        const documentsQuery = query(collection(db, 'artifacts', 'logicstrack-app', 'public', 'data', 'shipments', selectedShipment.id, 'documents'), orderBy('uploadedAt', 'desc'));
        unsubscribeShipmentDocuments = onSnapshot(documentsQuery, (snapshot) => {
            setShipmentFiles(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });
    } else {
        setIncidents([]);
        setShipmentFiles([]);
    }

    return () => {
        unsubscribeShipments();
        if (unsubscribeQuoteRequests) unsubscribeQuoteRequests();
        if (unsubscribeIncidents) unsubscribeIncidents();
        if (unsubscribeShipmentDocuments) unsubscribeShipmentDocuments();
    };
    }, [isAuthReady, auth, db, userId, userRole, selectedShipment]);

    const renderContent = () => {
        const isAdminOrSuper = userRole === 'admin' || userRole === 'superadmin';
        switch (activeTab) {
        case 'home':
    return (
        <div className="space-y-6">
            {/* Tarjeta de Bienvenida */}
            <div className="bg-white border border-gray-200 p-6 rounded-2xl shadow-sm">
                <h2 className="text-2xl font-bold text-gray-800">¡Bienvenido de nuevo! 👋</h2>
                <p className="text-md text-gray-600 mt-1 italic">{welcomeMessage}</p>
            </div>

            {/* Tarjetas de Resumen (KPIs) con nuevo diseño */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {/* Envíos Abiertos */}
                <div className="bg-white border border-gray-200 p-5 rounded-2xl shadow-sm flex items-center space-x-4">
                    <div className="bg-blue-100 p-3 rounded-full">
                        <span className="text-blue-600">📂</span>
                    </div>
                    <div>
                        <p className="text-gray-500 text-sm font-medium">Envíos Abiertos</p>
                        <p className="text-2xl font-bold text-gray-800">{groupedShipments['Envíos Abiertos']?.length || 0}</p>
                    </div>
                </div>
                {/* Envíos en Proceso */}
                <div className="bg-white border border-gray-200 p-5 rounded-2xl shadow-sm flex items-center space-x-4">
                    <div className="bg-yellow-100 p-3 rounded-full">
                        <span className="text-yellow-600">✈️</span>
                    </div>
                    <div>
                        <p className="text-gray-500 text-sm font-medium">Envíos en Proceso</p>
                        <p className="text-2xl font-bold text-gray-800">{groupedShipments['Envíos en Proceso']?.length || 0}</p>
                    </div>
                </div>
                {/* Envíos Cerrados */}
                <div className="bg-white border border-gray-200 p-5 rounded-2xl shadow-sm flex items-center space-x-4">
                    <div className="bg-green-100 p-3 rounded-full">
                        <span className="text-green-600">✅</span>
                    </div>
                    <div>
                        <p className="text-gray-500 text-sm font-medium">Envíos Cerrados</p>
                        <p className="text-2xl font-bold text-gray-800">{groupedShipments['Envíos Cerrados']?.length || 0}</p>
                    </div>
                </div>
            </div>

            {/* Gráficos de Rendimiento */}
            {recentDeliveredShipments.length > 0 ? (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <PerformanceChart title="Rendimiento Lead Time (últimos 5 entregados)" shipments={recentDeliveredShipments} slaConfig={slaConfig} timeKey={{ start: 'pickup_at', end: 'delivered_at', metric: 'leadTime' }} labelKey="días"/>
                    <PerformanceChart title="Rendimiento Tiempo en Aduana (últimos 5 entregados)" shipments={recentDeliveredShipments} slaConfig={slaConfig} timeKey={{ start: 'customs_clear_start', end: 'customs_clear_end', metric: 'customsTime' }} labelKey="días"/>
                </div>
            ) : (
                <div className="text-center p-6 bg-white border border-gray-200 rounded-2xl shadow-sm">
                    <p className="text-gray-500">No hay suficientes datos de envíos entregados para mostrar los gráficos de rendimiento.</p>
                </div>
            )}
        </div>
    );
        
        case 'shipments':
    if (isAdminOrSuper && isCreatingShipment) {
        // La vista de creación no cambia, pero se verá sobre el nuevo fondo gris claro
        return <CreateShipmentComponent db={db} onClose={() => setIsCreatingShipment(false)} allUsers={allUsers} />;
    }

    // Objeto para mapear los estados a colores para las etiquetas
    const statusStyles = {
        'Envíos Abiertos': 'bg-blue-100 text-blue-800 ring-blue-600/20',
        'Envíos en Proceso': 'bg-yellow-100 text-yellow-800 ring-yellow-600/20',
        'Envíos Cerrados': 'bg-green-100 text-green-800 ring-green-600/20',
    };

    return (
        <div className="space-y-6">
            {/* Encabezado de la página */}
            <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-4">
                <div>
                    <h2 className="text-3xl font-bold text-gray-800">Mis Envíos</h2>
                    <p className="text-gray-500 mt-1">Gestiona y revisa el estado de todos tus envíos.</p>
                </div>
                {isAdminOrSuper && 
                    <button 
                        onClick={() => setIsCreatingShipment(true)} 
                        className="bg-teal-500 text-white font-bold py-2 px-5 rounded-lg shadow-sm hover:bg-teal-600 transition-all duration-200"
                    >
                        + Crear Envío Nuevo
                    </button>
                }
            </div>

            {/* Pestañas de Filtro Rediseñadas */}
            <div className="flex items-center space-x-2 bg-gray-200 p-1.5 rounded-lg">
                {Object.keys(groupedShipments).map(groupName => (
                    <button 
                        key={groupName} 
                        onClick={() => setActiveShipmentGroup(groupName)}
                        className={`w-full text-center px-4 py-2 rounded-md font-semibold text-sm transition-all duration-200 ${activeShipmentGroup === groupName ? 'bg-white text-gray-800 shadow' : 'bg-transparent text-gray-600 hover:bg-gray-300/50'}`}
                    >
                        {groupName} ({groupedShipments[groupName].length})
                    </button>
                ))}
            </div>

            {/* Listado de Tarjetas de Envío */}
            <div className="space-y-4">
                {groupedShipments[activeShipmentGroup]?.length > 0 ? (
                    groupedShipments[activeShipmentGroup].map(shipment => {
                        const client = allUsers.find(u => u.uid === shipment.client_id);
                        return (
                            <div key={shipment.id} className="bg-white border border-gray-200 p-5 rounded-2xl shadow-sm transition-shadow hover:shadow-md">
                                <div className="flex flex-col sm:flex-row justify-between sm:items-start gap-4">
                                    {/* Información del Envío */}
                                    <div className="flex-grow">
                                        <div className="flex items-center gap-3 mb-2">
                                            <p className="font-bold text-lg text-gray-800">ID: {shipment.shipment_id}</p>
                                            <span className={`px-3 py-1 text-xs font-medium rounded-full ring-1 ring-inset ${statusStyles[activeShipmentGroup] || 'bg-gray-100 text-gray-800'}`}>
                                                {shipment.status}
                                            </span>
                                        </div>
                                        {client && <p className="text-sm text-gray-600">Cliente: <span className="font-medium">{client.name || client.email}</span></p>}
                                        <p className="text-sm text-gray-600">Ruta: <span className="font-medium">{shipment.origin} → {shipment.destination}</span></p>
                                    </div>

                                    {/* Botones de Acción */}
                                    <div className="flex-shrink-0 flex items-center gap-2 self-end sm:self-start">
                                        {isAdminOrSuper && 
                                            <button 
                                                onClick={() => handleDeleteShipment(shipment.id)} 
                                                className="text-gray-400 hover:text-red-600 p-2 rounded-full transition-colors"
                                                title="Borrar Envío"
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" /></svg>
                                            </button>
                                        }
                                        <button 
                                            onClick={() => setSelectedShipment(shipment)} 
                                            className="bg-teal-500 text-white font-bold py-2 px-5 rounded-lg shadow-sm hover:bg-teal-600 transition-all duration-200"
                                        >
                                            Ver Detalles
                                        </button>
                                    </div>
                                </div>

                                {/* Sección de Admin para Actualizar Estado */}
                                {isAdminOrSuper && (
                                    <div className="mt-4 pt-4 border-t border-gray-200">
                                        <label htmlFor={`status-select-${shipment.id}`} className="block text-sm font-medium text-gray-700 mb-1">Actualizar Estado:</label>
                                        <select 
                                            id={`status-select-${shipment.id}`} 
                                            value={shipment.status} 
                                            onChange={(e) => handleUpdateShipmentStatus(shipment.id, e.target.value)} 
                                            className="w-full p-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-teal-500"
                                        >
                                            <option value="" disabled>-- Selecciona un estado --</option>
                                            {SHIPMENT_STATUSES.map(status => (<option key={status} value={status}>{status}</option>))}
                                        </select>
                                    </div>
                                )}
                            </div>
                        );
                    })
                ) : (
                    <div className="text-center p-10 bg-white border border-gray-200 rounded-2xl shadow-sm">
                        <p className="text-gray-500">No hay envíos en esta categoría.</p>
                    </div>
                )}
            </div>
        </div>
    );

        case 'clasificacion':
                return <ClassificationContent 
                            db={db} 
                            userId={userId} 
                            classifiedDB={classifiedDB} 
                            handleClassifyProduct={handleClassifyProduct} 
                            newClassifiedProduct={newClassifiedProduct} 
                            setNewClassifiedProduct={setNewClassifiedProduct} 
                            userRole={userRole}
                            functions={functions} // Aquí se pasa el prop correctamente
                        />;
        
        case 'revisiones':
            return isAdminOrSuper ? <ClassificationReviewComponent db={db} auth={auth} /> : <p>Acceso denegado.</p>;
        
        case 'solicitudes':
             if (!isAdminOrSuper) return <p>Acceso denegado.</p>;
            return (
                <div className="bg-white p-6 rounded-xl shadow-lg border">
                    <h2 className="text-2xl font-bold mb-4">Solicitudes de Cotización ({quoteRequests.length})</h2>
                </div>
             );
        
        case 'admin':
            return isAdminOrSuper ? <AdminPanelComponent db={db} /> : <p>Acceso denegado.</p>;
        
        case 'database':
            return isAdminOrSuper ? <AdminDatabaseComponent db={db} allUsers={allUsers} /> : <p>Acceso denegado.</p>;
        
        case 'clientes':
            return <ClientDatabaseComponent db={db} allUsers={allUsers} userRole={userRole} userPermissions={userPermissions} logAction={logAction} />;
        
        case 'equipo':
            return userRole === 'superadmin' ? <AdminTeamManagement db={db} allUsers={allUsers} logAction={logAction} /> : <p>Acceso denegado.</p>;
        
        case 'historial':
             return <AuditLogViewer db={db} />;
        
        case 'reportes':
            return <ReportsComponent shipments={shipments} userRole={userRole} allUsers={allUsers} userId={userId} />;

        case 'privacidad':
            return (
                <div className="bg-white p-8 rounded-xl shadow-lg border prose max-w-4xl mx-auto">
                    <h1>Política de Privacidad de LogicsTrack</h1>
                    <p><strong>Última actualización: 01/09/2025</strong></p>
                    
                    <p>En LogicsTrack, valoramos tu privacidad y nos comprometemos a proteger la información personal que compartes con nosotros. Esta política describe cómo recopilamos, usamos, almacenamos y protegemos tus datos cuando utilizas nuestra aplicación.</p>

                    <h2>Información que Recopilamos</h2>
                    <p>Podemos recopilar los siguientes tipos de información:</p>
                    <ul>
                        <li><strong>Datos personales:</strong> nombre, correo electrónico, número de teléfono, empresa.</li>
                        <li><strong>Datos de ubicación:</strong> si habilitas el rastreo GPS, recopilamos tu ubicación en tiempo real para fines logísticos.</li>
                        <li><strong>Datos operativos:</strong> información sobre envíos, rutas, entregas, tiempos estimados, y otros datos relacionados con la operación logística.</li>
                        <li><strong>Datos técnicos:</strong> tipo de dispositivo, sistema operativo, dirección IP, y datos de uso de la app.</li>
                    </ul>

                    <h2>Cómo Usamos Tu Información</h2>
                    <p>Utilizamos tus datos para:</p>
                    <ul>
                        <li>Proporcionar y mejorar nuestros servicios logísticos.</li>
                        <li>Optimizar rutas y tiempos de entrega.</li>
                        <li>Enviar notificaciones relevantes sobre el estado de tus envíos.</li>
                        <li>Garantizar la seguridad y el funcionamiento correcto de la aplicación.</li>
                        <li>Cumplir con obligaciones legales y regulatorias.</li>
                    </ul>

                    <h2>Seguridad de los Datos</h2>
                    <p>Implementamos medidas técnicas y organizativas para proteger tu información contra accesos no autorizados, pérdida o alteración. Esto incluye:</p>
                    <ul>
                        <li>Cifrado de datos en tránsito y en reposo.</li>
                        <li>Autenticación segura de usuarios.</li>
                        <li>Monitoreo continuo de la infraestructura.</li>
                    </ul>

                    <h2>Compartir Información con Terceros</h2>
                    <p>No vendemos tu información personal. Podemos compartirla únicamente con:</p>
                    <ul>
                        <li>Proveedores de servicios que nos ayudan a operar la app (por ejemplo, servicios de hosting o mensajería).</li>
                        <li>Autoridades legales, si es requerido por ley.</li>
                        <li>Clientes o socios logísticos, solo cuando sea necesario para cumplir con la operación.</li>
                    </ul>

                    <h2>Tus Derechos</h2>
                    <p>Tienes derecho a:</p>
                    <ul>
                        <li>Acceder a tus datos personales.</li>
                        <li>Solicitar la corrección o eliminación de tus datos.</li>
                        <li>Retirar tu consentimiento para el uso de ciertos datos.</li>
                        <li>Solicitar la portabilidad de tus datos.</li>
                    </ul>
                    <p>Puedes ejercer estos derechos escribiéndonos a: Aduana@networldslogistics.com</p>

                    <h2>Retención de Datos</h2>
                    <p>Conservamos tu información solo durante el tiempo necesario para cumplir con los fines descritos en esta política, o según lo exija la ley.</p>

                    <h2>Transferencias Internacionales</h2>
                    <p>Si operamos fuera de tu país, tus datos pueden ser transferidos y almacenados en servidores ubicados en otras jurisdicciones. Nos aseguramos de que dichas transferencias cumplan con las leyes de protección de datos aplicables.</p>

                    <h2>Cambios a Esta Política</h2>
                    <p>Podemos actualizar esta política ocasionalmente. Te notificaremos sobre cambios importantes a través de la app o por correo electrónico.</p>
                    
                    <h2>Contacto</h2>
                    <p>Si tienes preguntas sobre esta política o sobre cómo manejamos tus datos, contáctanos en:</p>
                    <p>
                        Networld Logistics / LogicsTrack <br />
                        📧 Aduana@networldslogistics.com <br />
                        📍 Antiguo Cuscatlán, El Salvador
                    </p>
                </div>
            );

        default:
            return <p>Selecciona una pestaña.</p>;
    }
};
    
    let contentToRender;
    if (selectedShipment) {
        contentToRender = (
            <div className="bg-white p-6 rounded-xl shadow-lg border">
                <button onClick={() => setSelectedShipment(null)} className="mb-4 bg-gray-200 py-2 px-4 rounded-lg hover:bg-gray-300">
                    &larr; Volver a Envíos
                </button>
                <h2 className="text-3xl font-bold mb-4">Detalles del Envío: {selectedShipment.shipment_id}</h2>
                <div className="mt-6 pt-4 border-t">
                    <h3 className="text-xl font-bold mb-4">Archivo Digital del Envío</h3>
                    {userRole !== 'user' && (
                        <div className="mb-4 p-4 border rounded-lg bg-gray-50">
                            <label htmlFor="file-upload" className="block text-sm font-medium text-gray-700">Subir nuevo documento</label>
                            <input id="file-upload" type="file" onChange={handleFileUpload} className="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-teal-50 file:text-teal-700 hover:file:bg-teal-100" />
                            {uploadingFile && <p className="text-sm text-teal-600 mt-2">Subiendo archivo...</p>}
                        </div>
                    )}
                    {shipmentFiles.length > 0 ? (
                        <ul className="space-y-2">
                            {shipmentFiles.map(file => (
                                <li key={file.id} className="p-2 border rounded-md flex justify-between items-center bg-white hover:bg-gray-50">
                                    <a href={file.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline font-medium">
                                        {file.name}
                                    </a>
                                    <span className="text-xs text-gray-500">Subido por: {file.uploadedBy?.email || 'N/A'}</span>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-gray-500 italic">No hay documentos para este envío.</p>
                    )}
                </div>
                <div className="mt-6 pt-4 border-t">
                    <h3 className="text-xl font-bold mb-4">Historial de Incidencias</h3>
                    {incidents.length > 0 ? (
                        <div className="space-y-4">
                            {incidents.map(incident => (
                                <div key={incident.id} className={`p-4 border-l-4 rounded-r-lg ${incident.status === 'Resuelta' ? 'border-green-500' : 'border-yellow-500'}`}>
                                    <div className="flex justify-between items-center">
                                        <p className="font-bold">{incident.description}</p>
                                        <span className={`px-2 py-1 text-xs rounded-full ${incident.status === 'Resuelta' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`}>
                                            {incident.status}
                                        </span>
                                    </div>
                                    <p className="text-sm text-gray-500 mt-1">{new Date(incident.timestamp?.seconds * 1000).toLocaleString()}</p>
                                </div>
                            ))}
                        </div>
                    ) : (<p className="text-gray-500 italic">No se han registrado incidencias.</p>)}
                </div>
                {userRole !== 'user' && (
                    <div className="mt-6 pt-4 border-t">
                        <button onClick={() => setShowIncidentForm(!showIncidentForm)} className="bg-orange-500 text-white py-2 px-4 rounded-lg">
                            {showIncidentForm ? 'Cancelar' : '+ Registrar Incidencia'}
                        </button>
                        {showIncidentForm && (
                            <div className="mt-4 p-4 border rounded-lg space-y-3">
                                <h4>Nueva Incidencia</h4>
                                <div>
                                    <label>Descripción</label>
                                    <textarea value={newIncident.description} onChange={(e) => setNewIncident({ ...newIncident, description: e.target.value })} className="w-full p-2 border rounded-lg mt-1" rows="3"></textarea>
                                </div>
                                <div>
                                    <label>Estado</label>
                                    <select value={newIncident.status} onChange={(e) => setNewIncident({ ...newIncident, status: e.target.value })} className="w-full p-2 border rounded-lg mt-1">
                                        <option value="Abierta">Abierta</option><option value="En Proceso">En Proceso</option><option value="Resuelta">Resuelta</option>
                                    </select>
                                </div>
                                <button onClick={handleAddIncident} className="w-full bg-teal-600 text-white py-2 px-4 rounded-lg">Guardar Incidencia</button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    } else {
        contentToRender = renderContent();
    }

   return (
        <div className="min-h-screen bg-gray-100 font-['Inter'] flex">
            {/* --- ESTRUCTURA PRINCIPAL CON SIDEBAR CORREGIDA PARA TABLETS --- */}
            
            {/* Sidebar para Tablet y Escritorio (ahora se activa desde el tamaño 'md') */}
            <div className="hidden md:flex">
                 <Sidebar 
                    userRole={userRole} activeTab={activeTab} setActiveTab={setActiveTab} 
                    onLogout={onLogout} setVerifyAction={setVerifyAction} userEmail={userEmail} 
                 />
            </div>

            {/* Sidebar para Móvil (Overlay) (ahora solo para pantallas pequeñas, menores a 'md') */}
            <div className={`fixed inset-0 z-40 md:hidden transition-transform duration-300 ${isSidebarVisible ? 'translate-x-0' : '-translate-x-full'}`}>
                 <Sidebar 
                    userRole={userRole} activeTab={activeTab} setActiveTab={setActiveTab} 
                    onLogout={onLogout} setVerifyAction={setVerifyAction} userEmail={userEmail}
                 />
            </div>
            {isSidebarVisible && <div className="fixed inset-0 bg-black/50 z-30 md:hidden" onClick={() => setIsSidebarVisible(false)}></div>}


            {/* Contenido Principal */}
            <div className="flex-grow flex flex-col">
                {/* Header para Móvil con botón de menú (ahora solo para pantallas pequeñas) */}
                <header className="md:hidden bg-white shadow-md p-4 flex items-center">
                    <button onClick={() => setIsSidebarVisible(true)} className="text-gray-700">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>
                    </button>
                    <div className="flex-grow text-center">
                        <span className="text-lg font-bold text-gray-800">{activeTab ? activeTab.charAt(0).toUpperCase() + activeTab.slice(1) : ''}</span>
                    </div>
                </header>
                
                {/* Contenedor del contenido que ya tenías */}
                <main className="container mx-auto p-4 lg:p-8 flex-grow">
                    {contentToRender}
                </main>
            </div>

            {/* --- FIN DE LA ESTRUCTURA PRINCIPAL --- */}

            {/* Modal de Verificación (sin cambios) */}
            {verifyAction.show && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-xl space-y-4 w-full max-w-md">
                        <h3 className="text-xl font-bold">Verificación Requerida</h3>
                        <p>Para acceder a esta sección, por favor ingresa tu contraseña de nuevo.</p>
                        <form onSubmit={handleReauthenticate}>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full p-2 border rounded-lg mt-1"
                                placeholder="Tu contraseña"
                                required
                            />
                            <div className="flex justify-end space-x-2 mt-4">
                                <button type="button" onClick={() => setVerifyAction({ show: false, targetTab: null })} className="bg-gray-300 py-2 px-4 rounded">Cancelar</button>
                                <button type="submit" className="bg-teal-600 text-white font-bold py-2 px-4 rounded">Verificar</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};
// ### FIN DEL CÓDIGO CORREGIDO PARA MainApp ###


// --- REEMPLAZA TU COMPONENTE ROOT COMPLETO CON ESTE ---

// 1. INICIALIZACIÓN DE FIREBASE (AHORA FUERA DEL COMPONENTE)
// Asegúrate de que estas líneas estén JUSTO ANTES de tu componente Root
const firebaseApp = initializeApp(firebaseConfig);
const firestoreDb = getFirestore(firebaseApp);
const firebaseAuth = getAuth(firebaseApp);
const functions = getFunctions(getApp(), "us-central1");

// Ahora, reemplaza tu componente Root existente con este:
const Root = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userId, setUserId] = useState(null);
    const [userEmail, setUserEmail] = useState(null);
    const [userRole, setUserRole] = useState('user');
    const [userPermissions, setUserPermissions] = useState({});
    const [allUsers, setAllUsers] = useState([]);
    const [isAuthReady, setIsAuthReady] = useState(false);
    const [ratesConfig, setRatesConfig] = useState(null);
    const [arancelesConfig, setArancelesConfig] = useState(null);
    const [slaConfig, setSlaConfig] = useState(null);
    const [classifiedDB, setClassifiedDB] = useState([]);
    const superAdminUIDs = useMemo(() => ['vIygM0UbsaeyrlzlwgV4Zlvr4kJ2'], []);

    useEffect(() => {
        const appId = 'logicstrack-app';

        const ratesDocRef = doc(firestoreDb, 'artifacts', appId, 'public', 'data', 'ratesConfig', 'main');
        const unsubRates = onSnapshot(ratesDocRef, docSnap => setRatesConfig(docSnap.exists() ? docSnap.data() : {}));
        const arancelesDocRef = doc(firestoreDb, 'artifacts', appId, 'public', 'data', 'arancelesConfig', 'main');
        const unsubAranceles = onSnapshot(arancelesDocRef, docSnap => setArancelesConfig(docSnap.exists() ? docSnap.data() : {}));
        
        let unsubscribeUsers = () => {};
        let unsubscribeSla = () => {};
        let unsubscribeClassified = () => {};

        const unsubscribeAuth = onAuthStateChanged(firebaseAuth, async (user) => {
            if (user) {
                setUserId(user.uid);
                setUserEmail(user.email);
                
                const userDocRef = doc(firestoreDb, 'artifacts', appId, 'users', user.uid);
                const userDocSnap = await getDoc(userDocRef);
                
                const permissions = userDocSnap.exists() ? userDocSnap.data().permissions || {} : {};
                let determinedRole = 'user';
                if (superAdminUIDs.includes(user.uid)) {
                    determinedRole = 'superadmin';
                } else if (permissions.isAdmin) {
                    determinedRole = 'admin';
                }
                
                setUserPermissions(permissions);
                setUserRole(determinedRole);
                setIsLoggedIn(true);

                const slaDocRef = doc(firestoreDb, 'artifacts', appId, 'public', 'data', 'slaConfig', 'main');
                unsubscribeSla = onSnapshot(slaDocRef, docSnap => setSlaConfig(docSnap.exists() ? docSnap.data() : {}));
                
                const classifiedRef = collection(firestoreDb, "artifacts", appId, "users", user.uid, "classified_products");
                unsubscribeClassified = onSnapshot(classifiedRef, snapshot => setClassifiedDB(snapshot.docs.map(doc => ({...doc.data(), id: doc.id}))));

                if (determinedRole === 'admin' || determinedRole === 'superadmin') {
                    const usersCollectionRef = collection(firestoreDb, 'artifacts', appId, 'users');
                    unsubscribeUsers = onSnapshot(usersCollectionRef, snapshot => setAllUsers(snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }))));
                }
            } else {
                setIsLoggedIn(false);
                setUserId(null); setUserEmail(null); setUserRole('user'); setUserPermissions({});
                setAllUsers([]);
            }
            setIsAuthReady(true);
        });

        return () => { 
            unsubscribeAuth(); 
            unsubRates();
            unsubAranceles(); 
            unsubscribeUsers();
            unsubscribeSla();
            unsubscribeClassified();
        };
    }, [superAdminUIDs]);

    const handleLogin = (email, password) => signInWithEmailAndPassword(firebaseAuth, email, password);
    const handleRegister = (email, password) => createUserWithEmailAndPassword(firebaseAuth, email, password);
    const handleLogout = () => signOut(firebaseAuth);

    if (!isAuthReady || ratesConfig === null) {
        return <div className="flex justify-center items-center h-screen bg-gray-900 text-white">Cargando Configuración...</div>;
    }

    if (!isLoggedIn) {
        return <PublicPage onLogin={handleLogin} onRegister={handleRegister} db={firestoreDb} ratesConfig={ratesConfig} arancelesConfig={arancelesConfig} />;
    }
    
    return (
        <MainApp 
            db={firestoreDb} 
            auth={firebaseAuth}
            functions={functions} 
            userId={userId} 
            userEmail={userEmail} 
            userRole={userRole} 
            userPermissions={userPermissions} 
            onLogout={handleLogout} 
            isAuthReady={isAuthReady} 
            slaConfig={slaConfig} 
            allUsers={allUsers} 
            classifiedDB={classifiedDB} 
        />
    );
};

export default Root;